export const FilterGoLoader = {
  nm: 'Flow 3',
  ddd: 0,
  h: 300,
  w: 300,
  meta: { g: 'LottieFiles Figma v98' },
  layers: [
    {
      ty: 0,
      nm: 'Layer_1',
      sr: 1,
      st: 0,
      op: 133.06,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: true,
      ao: 0,
      ks: {
        a: { a: 0, k: [120, 91.4] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [150, 150], t: 0 },
            { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [150, 148], t: 60 },
            { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [150, 148], t: 72 },
            { s: [150, 150], t: 132 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      masksProperties: [
        {
          nm: '',
          inv: false,
          mode: 'a',
          x: { a: 0, k: 0 },
          o: { a: 0, k: 100 },
          pt: {
            a: 1,
            k: [
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [240, 0],
                      [240, 182.81],
                      [0, 182.81],
                      [0, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [240, 0],
                      [240, 182.81],
                      [0, 182.81],
                      [0, 0],
                    ],
                  },
                ],
                t: 60,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [240, 0],
                      [240, 182.81],
                      [0, 182.81],
                      [0, 0],
                    ],
                  },
                ],
                t: 72,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [240, 0],
                      [240, 182.81],
                      [0, 182.81],
                      [0, 0],
                    ],
                  },
                ],
                t: 132,
              },
            ],
          },
        },
      ],
      w: 300,
      h: 300,
      refId: '1',
      ind: 1,
    },
    {
      ty: 0,
      nm: 'Component 3',
      sr: 1,
      st: 0,
      op: 133.06,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: true,
      ao: 0,
      ks: {
        a: { a: 0, k: [3, 132.59] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [96.85, 97.78] },
        r: { a: 0, k: 45 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      masksProperties: [
        {
          nm: '',
          inv: false,
          mode: 'a',
          x: { a: 0, k: 0 },
          o: { a: 0, k: 100 },
          pt: {
            a: 1,
            k: [
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 262.18],
                      [3, 265.18],
                      [3, 265.18],
                      [0, 262.18],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 262.18],
                      [3, 265.18],
                      [3, 265.18],
                      [0, 262.18],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 60,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 262.18],
                      [3, 265.18],
                      [3, 265.18],
                      [0, 262.18],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 72,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 262.18],
                      [3, 265.18],
                      [3, 265.18],
                      [0, 262.18],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 132,
              },
            ],
          },
        },
      ],
      w: 300,
      h: 300,
      refId: '2',
      ind: 2,
    },
    {
      ty: 0,
      nm: 'Component 5',
      sr: 1,
      st: 0,
      op: 133.06,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: true,
      ao: 0,
      ks: {
        a: { a: 0, k: [3, 65] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [248.75, 145.06] },
        r: { a: 0, k: 45 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      masksProperties: [
        {
          nm: '',
          inv: false,
          mode: 'a',
          x: { a: 0, k: 0 },
          o: { a: 0, k: 100 },
          pt: {
            a: 1,
            k: [
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 127],
                      [3, 130],
                      [3, 130],
                      [0, 127],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 127],
                      [3, 130],
                      [3, 130],
                      [0, 127],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 60,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 127],
                      [3, 130],
                      [3, 130],
                      [0, 127],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 72,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 127],
                      [3, 130],
                      [3, 130],
                      [0, 127],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 132,
              },
            ],
          },
        },
      ],
      w: 300,
      h: 300,
      refId: '4',
      ind: 3,
    },
    {
      ty: 0,
      nm: 'Component 4',
      sr: 1,
      st: 0,
      op: 133.06,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: true,
      ao: 0,
      ks: {
        a: { a: 0, k: [3, 90] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [124.38, 197.81] },
        r: { a: 0, k: 45 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      masksProperties: [
        {
          nm: '',
          inv: false,
          mode: 'a',
          x: { a: 0, k: 0 },
          o: { a: 0, k: 100 },
          pt: {
            a: 1,
            k: [
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 177],
                      [3, 180],
                      [3, 180],
                      [0, 177],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 177],
                      [3, 180],
                      [3, 180],
                      [0, 177],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 60,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 177],
                      [3, 180],
                      [3, 180],
                      [0, 177],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 72,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 1.66],
                      [0, 0],
                      [-1.66, 0],
                      [0, 0],
                      [0, -1.66],
                      [0, 0],
                      [1.66, 0],
                    ],
                    v: [
                      [6, 3],
                      [6, 177],
                      [3, 180],
                      [3, 180],
                      [0, 177],
                      [0, 3],
                      [3, 0],
                      [3, 0],
                    ],
                  },
                ],
                t: 132,
              },
            ],
          },
        },
      ],
      w: 300,
      h: 300,
      refId: '6',
      ind: 4,
    },
  ],
  v: '5.7.0',
  fr: 60,
  op: 132.06,
  ip: 0,
  assets: [
    {
      nm: '[Asset] Layer_1',
      id: '1',
      layers: [
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [36.6, 3.89] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [47.96, 62.76], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [45.16, 67.33], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [45.16, 67.33], t: 72 },
                { s: [47.96, 62.76], t: 132 },
              ],
            },
            r: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 72 },
                { s: [0], t: 132 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [8.61, 3.76],
                    [-0.12, 0.27],
                    [-0.27, -0.12],
                    [-8.32, 3.09],
                    [-1.87, 0.55],
                    [-12.5, -5.03],
                    [0.11, -0.27],
                    [0.27, 0.11],
                    [9.13, -2.67],
                    [1.83, -0.68],
                    [6.16, 0],
                    [0, 0],
                  ],
                  o: [
                    [-5.36, 0],
                    [-0.27, -0.12],
                    [0.12, -0.27],
                    [18.11, 7.91],
                    [1.77, -0.66],
                    [9.37, -2.74],
                    [0.27, 0.11],
                    [-0.11, 0.27],
                    [-12.27, -4.94],
                    [-1.84, 0.54],
                    [-4.55, 1.69],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [20.79, 7.78],
                    [0.32, 2.72],
                    [0.05, 2.02],
                    [0.75, 1.75],
                    [35.78, 3.37],
                    [41.25, 1.49],
                    [72.87, 4.8],
                    [73.16, 5.49],
                    [72.47, 5.78],
                    [41.54, 2.5],
                    [36.14, 4.36],
                    [20.79, 7.77],
                    [20.79, 7.78],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 1,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [7.25, 4.27] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [35.52, 95.01], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [36.39, 100.77], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [36.39, 100.77], t: 72 },
                { s: [35.52, 95.01], t: 132 },
              ],
            },
            r: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 72 },
                { s: [0], t: 132 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [4.13, 4.47],
                    [0, 0],
                    [-0.22, 0.2],
                    [-0.2, -0.22],
                    [0, 0],
                    [-6.17, 0],
                    [-0.01, 0],
                    [0, -0.3],
                    [0.3, 0],
                    [0.05, 0],
                    [0, 0],
                  ],
                  o: [
                    [-6.64, 0],
                    [0, 0],
                    [-0.2, -0.21],
                    [0.21, -0.2],
                    [0, 0],
                    [4.08, 4.42],
                    [0.05, 0],
                    [0.29, 0],
                    [0, 0.3],
                    [-0.05, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [13.84, 8.53],
                    [0.33, 1.09],
                    [0.14, 0.89],
                    [0.17, 0.14],
                    [0.92, 0.17],
                    [1.11, 0.37],
                    [13.84, 7.47],
                    [13.97, 7.47],
                    [14.5, 8],
                    [13.97, 8.53],
                    [13.83, 8.53],
                    [13.84, 8.53],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 2,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [36.37, 9.14] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [69.18, 97.65], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [70.13, 99.65], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [70.13, 99.65], t: 72 },
                { s: [69.18, 97.65], t: 132 },
              ],
            },
            r: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 72 },
                { s: [0], t: 132 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [5.64, 3.59],
                    [-0.16, 0.25],
                    [-0.25, -0.16],
                    [-11.83, 3.8],
                    [-4.46, 2.59],
                    [-10.36, -1.02],
                    [0.02, -0.29],
                    [0.28, 0.01],
                    [7.65, -4.45],
                    [5.44, -1.75],
                    [4.4, 0],
                    [0, 0],
                  ],
                  o: [
                    [-6.71, 0],
                    [-0.25, -0.16],
                    [0.16, -0.25],
                    [9.07, 5.76],
                    [5.33, -1.71],
                    [7.81, -4.54],
                    [0.29, 0.03],
                    [-0.03, 0.29],
                    [-10.01, -0.99],
                    [-4.51, 2.63],
                    [-4.81, 1.54],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [18.82, 18.26],
                    [0.25, 12.88],
                    [0.09, 12.15],
                    [0.82, 11.99],
                    [32.32, 14.94],
                    [46.73, 7.95],
                    [72.27, 0.15],
                    [72.75, 0.73],
                    [72.17, 1.21],
                    [47.27, 8.87],
                    [32.65, 15.96],
                    [18.83, 18.27],
                    [18.82, 18.26],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 3,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [45.17, 4.69] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [59.05, 79.25], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [58.02, 82.48], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [58.02, 82.48], t: 72 },
                { s: [59.05, 79.25], t: 132 },
              ],
            },
            r: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 72 },
                { s: [0], t: 132 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.12, 0],
                    [7.32, 4.9],
                    [-0.16, 0.25],
                    [-0.25, -0.16],
                    [-8.95, -0.05],
                    [-5.82, 1.36],
                    [-20.97, -5.7],
                    [0.08, -0.28],
                    [0.28, 0.08],
                    [10.74, -2.51],
                    [7.75, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.12, 0],
                    [-9.14, -0.05],
                    [-0.24, -0.16],
                    [0.16, -0.24],
                    [7.16, 4.8],
                    [7.79, 0.05],
                    [10.39, -2.43],
                    [0.28, 0.08],
                    [-0.08, 0.28],
                    [-20.71, -5.64],
                    [-5.8, 1.36],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [28.55, 9.39],
                    [28.2, 9.39],
                    [0.24, 0.98],
                    [0.09, 0.24],
                    [0.83, 0.09],
                    [28.2, 8.32],
                    [47.84, 5.59],
                    [89.95, 6.35],
                    [90.32, 7],
                    [89.67, 7.37],
                    [48.08, 6.62],
                    [28.54, 9.38],
                    [28.55, 9.39],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 4,
        },
        {
          ty: 4,
          nm: 'Group',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [7.08, 5.47] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [119.23, 30.97] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [],
          ind: 5,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [7.08, 4.49] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [7.08, 4.49] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.01, -0.01],
                    [0.24, 0.17],
                    [0.05, -0.05],
                    [-0.13, -1.25],
                    [-0.23, -0.32],
                    [0.06, -0.03],
                    [0.49, -0.1],
                    [0.06, 0.49],
                    [-1.51, 1.42],
                    [-2.07, 0.59],
                    [0.03, -0.07],
                    [-0.27, -0.1],
                    [-0.07, 0],
                    [-0.08, 0.21],
                    [-0.05, 0.31],
                    [-2.07, -1.45],
                    [0.14, -0.23],
                  ],
                  o: [
                    [0, 0],
                    [-0.17, 0.24],
                    [-5.08, -3.56],
                    [-1.25, 1.17],
                    [0.05, 0.43],
                    [-0.06, 0],
                    [0, 0.01],
                    [-0.24, -0.4],
                    [-0.18, -1.6],
                    [0.8, -0.75],
                    [-0.01, 0.08],
                    [-0.1, 0.27],
                    [0.07, 0.03],
                    [0.21, 0],
                    [0.1, -0.26],
                    [1.91, -0.32],
                    [0.22, 0.16],
                    [0, 0],
                  ],
                  v: [
                    [14.09, 2.19],
                    [14.07, 2.24],
                    [13.33, 2.37],
                    [2.86, 3.64],
                    [1.08, 7.51],
                    [1.5, 8.65],
                    [1.32, 8.7],
                    [0.47, 8.97],
                    [0.03, 7.62],
                    [2.13, 2.87],
                    [6.66, 0.38],
                    [6.59, 0.61],
                    [6.89, 1.29],
                    [7.09, 1.33],
                    [7.58, 0.99],
                    [7.82, 0.12],
                    [13.94, 1.5],
                    [14.09, 2.19],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 6,
          parent: 5,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [4.75, 1.84] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [5.95, 9.11] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [2.69, 0],
                    [0.84, 0.49],
                    [0.16, 0.14],
                    [-0.03, 0.01],
                    [-0.01, 0.18],
                    [-0.06, -0.04],
                    [-1.17, 0.9],
                    [-0.18, -0.23],
                    [0.23, -0.18],
                  ],
                  o: [
                    [-0.99, 0.76],
                    [-0.86, 0],
                    [-0.18, -0.11],
                    [0.34, -0.11],
                    [0.18, -0.08],
                    [0.05, 0.04],
                    [2.88, 1.7],
                    [0.23, -0.18],
                    [0.17, 0.23],
                    [0, 0],
                  ],
                  v: [
                    [9.3, 0.95],
                    [3.08, 3.67],
                    [0.51, 2.98],
                    [0, 2.61],
                    [0.58, 2.38],
                    [0.87, 1.94],
                    [1.05, 2.06],
                    [8.65, 0.11],
                    [9.4, 0.2],
                    [9.3, 0.95],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 7,
          parent: 5,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [6.06, 10.78] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [108.17, 30.64] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.18, -0.08],
                    [0.34, -0.11],
                    [0.56, 0],
                    [0.59, 0.36],
                    [0.05, -0.02],
                    [0.19, -1.88],
                    [0.27, 0],
                    [0, 0],
                    [-0.03, 0.29],
                    [-2.93, 1.16],
                    [-0.21, 1],
                    [1.13, 0],
                    [0.53, 0.31],
                    [-0.86, 2.69],
                    [-1.18, 1.24],
                    [0, 0],
                    [-0.21, -0.2],
                    [0.2, -0.21],
                    [0, 0],
                    [0.48, -1.47],
                    [-0.83, -0.49],
                    [-0.7, 0.98],
                    [0, 0],
                    [-0.09, 0.13],
                    [-0.02, 0.01],
                    [-0.02, 0.02],
                    [0.53, 2.49],
                    [0.11, 0.26],
                    [0.08, 0.15],
                    [-0.26, 0.13],
                    [-0.14, -0.26],
                    [-0.01, -0.01],
                    [-0.06, -0.15],
                    [1.24, -1.79],
                    [0.01, -0.02],
                    [-1.29, -0.99],
                    [-0.61, 0.12],
                    [-0.01, 0.01],
                    [-0.06, 0.01],
                    [-0.09, -0.2],
                    [0.01, -0.09],
                  ],
                  o: [
                    [0, 0.18],
                    [-0.03, 0],
                    [-0.36, 0.11],
                    [-0.56, 0],
                    [-0.04, 0.04],
                    [-2.61, 0.83],
                    [-0.03, 0.27],
                    [0, 0],
                    [-0.29, -0.03],
                    [0.21, -1.99],
                    [-0.76, -0.91],
                    [-0.87, 0.68],
                    [-0.54, 0],
                    [-0.76, -0.45],
                    [0.55, -1.69],
                    [0, 0],
                    [0.19, -0.21],
                    [0.22, 0.2],
                    [0, 0],
                    [-1.15, 1.23],
                    [-0.57, 1.79],
                    [1.86, 1.1],
                    [0, 0],
                    [0.08, -0.11],
                    [0, -0.02],
                    [0.02, -0.03],
                    [1.01, -1.47],
                    [-0.05, -0.27],
                    [-0.06, -0.15],
                    [-0.14, -0.26],
                    [0.26, -0.15],
                    [0.01, 0],
                    [0.08, 0.15],
                    [1.37, 3.24],
                    [-0.01, 0.02],
                    [-1.45, 2.47],
                    [0.67, 0.52],
                    [0.49, -0.1],
                    [0.06, -0.03],
                    [0.21, -0.02],
                    [0.04, 0.09],
                    [0, 0],
                  ],
                  v: [
                    [12.11, 14.84],
                    [11.82, 15.28],
                    [11.24, 15.51],
                    [9.81, 15.73],
                    [8.03, 15.25],
                    [7.88, 15.33],
                    [3.43, 21.08],
                    [2.9, 21.55],
                    [2.85, 21.55],
                    [2.37, 20.97],
                    [7.16, 14.47],
                    [6.54, 11.47],
                    [3.44, 12.73],
                    [1.83, 12.29],
                    [0.24, 7.8],
                    [3.3, 3.45],
                    [3.77, 2.95],
                    [4.51, 2.92],
                    [4.54, 3.67],
                    [4.07, 4.17],
                    [1.25, 8.13],
                    [2.37, 11.38],
                    [7.41, 9.13],
                    [7.47, 9.03],
                    [7.73, 8.66],
                    [7.75, 8.62],
                    [7.81, 8.54],
                    [9.85, 2.02],
                    [9.61, 1.22],
                    [9.4, 0.78],
                    [9.62, 0.07],
                    [10.34, 0.28],
                    [10.36, 0.32],
                    [10.57, 0.78],
                    [8.67, 9.16],
                    [8.64, 9.22],
                    [8.41, 14.22],
                    [10.51, 14.6],
                    [11.36, 14.33],
                    [11.54, 14.28],
                    [12.06, 14.57],
                    [12.11, 14.84],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 8,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [2.84, 3.01] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [103.6, 21.19] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.92, -1.58],
                    [0.18, 0],
                    [0.09, 0.05],
                    [0.04, 0.08],
                    [-0.1, 0.17],
                    [-2.38, 1.36],
                    [-0.16, -0.13],
                    [-0.04, -0.06],
                    [0.25, -0.14],
                  ],
                  o: [
                    [-2.16, 1.23],
                    [-0.1, 0.17],
                    [-0.09, 0],
                    [-0.08, -0.05],
                    [-0.09, -0.16],
                    [0.99, -1.69],
                    [0.2, -0.11],
                    [0.06, 0.04],
                    [0.14, 0.25],
                    [0, 0],
                  ],
                  v: [
                    [5.41, 0.99],
                    [0.99, 5.77],
                    [0.53, 6.03],
                    [0.26, 5.96],
                    [0.07, 5.76],
                    [0.07, 5.23],
                    [4.88, 0.07],
                    [5.47, 0.12],
                    [5.61, 0.27],
                    [5.41, 0.99],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 9,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [2.22, 3.38] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [99.33, 40.35] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.1, 0.1],
                    [0.58, 2.87],
                    [-0.29, 0.05],
                    [-0.05, -0.29],
                    [-0.8, -0.77],
                    [0.21, -0.21],
                    [0.14, 0],
                  ],
                  o: [
                    [-0.13, 0],
                    [-0.87, -0.84],
                    [-0.06, -0.29],
                    [0.29, -0.06],
                    [0.52, 2.57],
                    [0.21, 0.2],
                    [-0.1, 0.11],
                    [0, 0],
                  ],
                  v: [
                    [3.91, 6.76],
                    [3.54, 6.61],
                    [0.01, 0.63],
                    [0.43, 0.01],
                    [1.05, 0.43],
                    [4.28, 5.85],
                    [4.29, 6.6],
                    [3.91, 6.76],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 10,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [0.83, 3.15] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [119.29, 23.68] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.1, -0.26],
                    [0.21, 0],
                    [0.07, 0.03],
                    [-0.1, 0.27],
                    [-0.01, 0.08],
                    [0.57, 1.14],
                    [-0.09, 0.15],
                    [-0.09, 0.05],
                    [-0.14, -0.26],
                    [-0.11, -0.72],
                    [0.18, -0.88],
                  ],
                  o: [
                    [-0.05, 0.31],
                    [-0.08, 0.21],
                    [-0.07, 0],
                    [-0.27, -0.1],
                    [0.03, -0.07],
                    [0.42, -1.3],
                    [-0.08, -0.17],
                    [0.05, -0.09],
                    [0.27, -0.14],
                    [0.26, 0.53],
                    [0.13, 0.96],
                    [0, 0],
                  ],
                  v: [
                    [1.5, 5.09],
                    [1.26, 5.96],
                    [0.77, 6.3],
                    [0.57, 6.26],
                    [0.27, 5.58],
                    [0.34, 5.35],
                    [0.05, 0.77],
                    [0.07, 0.26],
                    [0.28, 0.06],
                    [1, 0.29],
                    [1.56, 2.22],
                    [1.5, 5.09],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 11,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3.84, 1.07] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [108.18, 46.36] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [1.84, 0.86],
                    [-0.13, 0.26],
                    [-0.26, -0.13],
                    [-1.72, 0.3],
                    [-0.05, -0.29],
                    [0.29, -0.05],
                    [0.79, 0],
                    [0, 0],
                  ],
                  o: [
                    [-1.36, 0],
                    [-0.26, -0.12],
                    [0.12, -0.26],
                    [2.64, 1.24],
                    [0.29, -0.05],
                    [0.05, 0.29],
                    [-0.66, 0.11],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [5.06, 2.12],
                    [0.3, 1],
                    [0.05, 0.3],
                    [0.75, 0.05],
                    [7.06, 0.88],
                    [7.67, 1.31],
                    [7.24, 1.92],
                    [5.06, 2.13],
                    [5.06, 2.12],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 12,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [19.25, 21.73] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [115.08, 28.82] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [2.75, 0.76],
                    [1.71, -4.58],
                    [1.04, -1.52],
                    [0.18, -0.88],
                    [0.1, -0.26],
                    [0.21, 0],
                    [0.07, 0.03],
                    [-0.1, 0.27],
                    [-0.01, 0.08],
                    [0.57, 1.14],
                    [-0.09, 0.15],
                    [1.72, -1.44],
                    [1.69, -0.84],
                    [0.03, -0.02],
                    [-0.04, -0.06],
                    [0.25, -0.14],
                    [0.92, -1.58],
                    [0.18, 0],
                    [0.09, 0.05],
                    [0.04, 0.08],
                    [-1.02, -3.78],
                    [-0.05, -0.15],
                    [0.15, -0.18],
                    [-3.73, -2.65],
                    [-0.91, -0.42],
                    [-0.49, -0.17],
                    [-0.52, 4.32],
                    [8.35, 6.2],
                    [-2.62, 6.47],
                  ],
                  o: [
                    [1.21, -2.99],
                    [-2.74, -0.76],
                    [-1.73, 4.6],
                    [0.13, 0.96],
                    [-0.05, 0.31],
                    [-0.08, 0.21],
                    [-0.07, 0],
                    [-0.27, -0.1],
                    [0.03, -0.07],
                    [0.42, -1.3],
                    [-0.08, -0.17],
                    [-1.5, -1.8],
                    [-0.9, -2.5],
                    [-0.03, 0.02],
                    [0.06, 0.04],
                    [0.14, 0.25],
                    [-2.16, 1.23],
                    [-0.1, 0.17],
                    [-0.09, 0],
                    [-0.08, -0.05],
                    [-2.55, 4.14],
                    [0.04, 0.16],
                    [-0.18, 0.17],
                    [-2.71, 3.14],
                    [0.74, 0.54],
                    [0.41, 0.21],
                    [3.42, 1.25],
                    [5.11, 1.44],
                    [3.05, -3.92],
                    [0, 0],
                  ],
                  v: [
                    [37.92, 7.43],
                    [35.71, 0.19],
                    [29.58, 5.52],
                    [24.2, 15.66],
                    [24.14, 18.53],
                    [23.9, 19.4],
                    [23.41, 19.74],
                    [23.21, 19.7],
                    [22.91, 19.02],
                    [22.98, 18.79],
                    [22.69, 14.21],
                    [22.71, 13.7],
                    [16.72, 13.03],
                    [10.49, 11.15],
                    [10.4, 11.2],
                    [10.54, 11.35],
                    [10.34, 12.07],
                    [5.92, 16.85],
                    [5.46, 17.11],
                    [5.19, 17.04],
                    [5, 16.84],
                    [1.73, 29.89],
                    [1.87, 30.35],
                    [1.38, 30.87],
                    [3.91, 40.58],
                    [6.4, 42.02],
                    [7.76, 42.6],
                    [16.57, 39.97],
                    [30.41, 20.61],
                    [37.92, 7.43],
                  ],
                },
              },
            },
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.59, 0.36],
                    [0.05, -0.02],
                    [0.19, -1.88],
                    [0.27, 0],
                    [0, 0],
                    [-0.03, 0.29],
                    [-2.93, 1.16],
                    [-0.21, 1],
                    [1.13, 0],
                    [0.53, 0.31],
                    [-0.86, 2.69],
                    [-1.18, 1.24],
                    [0, 0],
                    [-0.21, -0.2],
                    [0.2, -0.21],
                    [0, 0],
                    [0.48, -1.47],
                    [-0.83, -0.49],
                    [-0.7, 0.98],
                    [0, 0],
                    [-0.09, 0.13],
                    [-0.02, 0.01],
                    [-0.02, 0.02],
                    [0.53, 2.49],
                    [0.11, 0.26],
                    [0.08, 0.15],
                    [-0.26, 0.13],
                    [-0.14, -0.26],
                    [-0.01, -0.01],
                    [-0.06, -0.15],
                    [1.24, -1.79],
                    [0.01, -0.02],
                    [-1.29, -0.99],
                    [-0.61, 0.12],
                    [-0.01, 0.01],
                    [-0.06, 0.01],
                    [-0.09, -0.2],
                    [0.01, -0.09],
                    [0.18, -0.08],
                    [0.34, -0.11],
                    [0.56, 0],
                  ],
                  o: [
                    [-0.57, 0],
                    [-0.04, 0.04],
                    [-2.61, 0.83],
                    [-0.03, 0.27],
                    [0, 0],
                    [-0.29, -0.03],
                    [0.21, -1.99],
                    [-0.76, -0.91],
                    [-0.87, 0.68],
                    [-0.54, 0],
                    [-0.76, -0.45],
                    [0.55, -1.69],
                    [0, 0],
                    [0.19, -0.21],
                    [0.22, 0.2],
                    [0, 0],
                    [-1.15, 1.23],
                    [-0.57, 1.79],
                    [1.86, 1.1],
                    [0, 0],
                    [0.08, -0.11],
                    [0, -0.02],
                    [0.02, -0.03],
                    [1.01, -1.47],
                    [-0.05, -0.27],
                    [-0.06, -0.15],
                    [-0.14, -0.26],
                    [0.26, -0.15],
                    [0.01, 0],
                    [0.08, 0.15],
                    [1.37, 3.24],
                    [-0.01, 0.02],
                    [-1.45, 2.47],
                    [0.67, 0.52],
                    [0.49, -0.1],
                    [0.06, -0.03],
                    [0.21, -0.02],
                    [0.04, 0.09],
                    [0, 0.18],
                    [-0.03, 0],
                    [-0.36, 0.11],
                    [0, 0],
                  ],
                  v: [
                    [16.09, 28.51],
                    [14.31, 28.03],
                    [14.16, 28.11],
                    [9.71, 33.86],
                    [9.18, 34.33],
                    [9.13, 34.33],
                    [8.65, 33.75],
                    [13.44, 27.25],
                    [12.82, 24.25],
                    [9.72, 25.51],
                    [8.11, 25.07],
                    [6.52, 20.58],
                    [9.58, 16.23],
                    [10.05, 15.73],
                    [10.79, 15.7],
                    [10.82, 16.45],
                    [10.35, 16.95],
                    [7.53, 20.91],
                    [8.65, 24.16],
                    [13.69, 21.91],
                    [13.75, 21.81],
                    [14.01, 21.44],
                    [14.03, 21.4],
                    [14.09, 21.32],
                    [16.13, 14.8],
                    [15.89, 14],
                    [15.68, 13.56],
                    [15.9, 12.85],
                    [16.62, 13.06],
                    [16.64, 13.1],
                    [16.85, 13.56],
                    [14.95, 21.94],
                    [14.92, 22],
                    [14.69, 27],
                    [16.79, 27.38],
                    [17.64, 27.11],
                    [17.82, 27.06],
                    [18.34, 27.35],
                    [18.39, 27.62],
                    [18.1, 28.06],
                    [17.52, 28.29],
                    [16.09, 28.51],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 13,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [2.18, 4.69] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [134.98, 10.76] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [100], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 72 },
                { s: [100], t: 132 },
              ],
            },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.08, 0.04],
                    [-0.13, 0.26],
                    [0.68, 1.6],
                    [1.42, 0.41],
                    [-0.08, 0.29],
                    [-0.28, -0.08],
                    [-0.62, -1.46],
                    [0.95, -1.77],
                    [0.19, 0],
                  ],
                  o: [
                    [-0.08, 0],
                    [-0.26, -0.14],
                    [0.81, -1.5],
                    [-0.34, -0.81],
                    [-0.28, -0.08],
                    [0.08, -0.28],
                    [1.44, 0.42],
                    [0.79, 1.88],
                    [-0.1, 0.18],
                    [0, 0],
                  ],
                  v: [
                    [3.09, 9.37],
                    [2.84, 9.31],
                    [2.62, 8.59],
                    [2.84, 3.31],
                    [0.38, 1.04],
                    [0.02, 0.38],
                    [0.68, 0.02],
                    [3.83, 2.89],
                    [3.56, 9.09],
                    [3.09, 9.37],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 14,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [11.24, 17.11] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [105.99, 63.92] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [2.14, 3.73],
                    [-4.37, 6.67],
                    [-1.02, -0.67],
                    [0.67, -1.03],
                    [-3.37, -5.89],
                    [-6.91, 0.35],
                    [-0.06, -1.22],
                    [1.22, -0.06],
                    [0.56, 0],
                    [0, 0],
                  ],
                  o: [
                    [-9.66, 0],
                    [-4.46, -7.78],
                    [0.67, -1.02],
                    [1.02, 0.67],
                    [-3.77, 5.75],
                    [2.39, 4.18],
                    [1.21, -0.06],
                    [0.06, 1.22],
                    [-0.59, 0.03],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [18.66, 34.21],
                    [2.3, 26.17],
                    [4.89, 1],
                    [7.96, 0.36],
                    [8.6, 3.43],
                    [6.15, 23.97],
                    [20.17, 29.74],
                    [22.49, 31.84],
                    [20.39, 34.16],
                    [18.66, 34.2],
                    [18.66, 34.21],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 15,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [0.03, 0.02] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [170.5, 44.19] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.02, 0],
                    [0, 0.02],
                    [-0.02, -0.01],
                  ],
                  o: [
                    [0, 0],
                    [-0.01, -0.01],
                    [0.02, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.05, 0.02],
                    [0.01, 0.04],
                    [0, 0],
                    [0.05, 0.02],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 16,
        },
        {
          ty: 4,
          nm: 'Group',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [24.82, 6.72] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [164.86, 45.09], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [167.5, 49.4], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [167.5, 49.4], t: 72 },
                { s: [164.86, 45.09], t: 132 },
              ],
            },
            r: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [14.16], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [14.16], t: 72 },
                { s: [0], t: 132 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [],
          ind: 17,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [11.39, 2.84] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [17.41, 8.93] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [2.13, -0.92],
                    [0.71, -0.17],
                    [0.4, -0.08],
                    [0.2, -0.03],
                    [0.11, -0.02],
                    [0, 0],
                    [0, 0],
                    [1.91, 0.04],
                    [1, 0.08],
                    [0.49, 0.05],
                    [0.23, 0.03],
                    [0.29, 0.04],
                    [0.26, 0.04],
                    [-2.86, 0.87],
                    [-3.41, -0.29],
                    [-1.58, -0.35],
                  ],
                  o: [
                    [-1.92, 1.3],
                    [-0.67, 0.29],
                    [-0.41, 0.1],
                    [-0.2, 0.03],
                    [-0.1, 0.02],
                    [0, 0],
                    [0, 0],
                    [-1.89, 0.23],
                    [-1.01, -0.02],
                    [-0.49, -0.05],
                    [-0.23, -0.03],
                    [-0.28, -0.04],
                    [-0.26, -0.04],
                    [2.45, -1.73],
                    [3.25, -0.99],
                    [1.61, 0.14],
                    [0, 0],
                  ],
                  v: [
                    [22.77, 0.87],
                    [16.77, 4.32],
                    [14.68, 4.99],
                    [13.47, 5.24],
                    [12.87, 5.33],
                    [12.56, 5.38],
                    [12.53, 5.38],
                    [12.29, 5.41],
                    [6.57, 5.66],
                    [3.56, 5.51],
                    [2.08, 5.37],
                    [1.4, 5.29],
                    [0.77, 5.2],
                    [0, 5.08],
                    [7.96, 1.07],
                    [17.98, 0.11],
                    [22.77, 0.87],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 18,
          parent: 17,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [24.82, 6.72] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [24.82, 6.72] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [2.41, -0.14],
                    [2.22, -1.18],
                    [1.8, -1.24],
                    [0.02, 0],
                    [0, 0.02],
                    [3.71, -0.26],
                    [3.13, -1.54],
                    [1.62, -1.22],
                    [0.06, -0.08],
                    [0.69, 0.23],
                    [0.31, 0.13],
                    [0.2, -0.21],
                    [0.03, -0.11],
                    [-0.25, -0.19],
                    [0, 0],
                    [-0.03, -0.02],
                    [0, 0],
                    [-0.03, -0.01],
                    [-1.48, -0.27],
                    [-1.88, -0.12],
                    [-1.92, 0.12],
                    [-1.67, 0.44],
                    [-0.55, 0.22],
                    [-4.49, -0.05],
                    [0, 0],
                    [-2.98, 1.34],
                    [-1.07, 0.86],
                    [1.01, 2.34],
                  ],
                  o: [
                    [-1.02, -2.33],
                    [-2.54, 0.15],
                    [-1.93, 1.02],
                    [-0.01, 0.01],
                    [-0.01, -0.01],
                    [-3.6, -0.92],
                    [-3.49, 0.25],
                    [-1.83, 0.9],
                    [-0.08, 0.06],
                    [-0.71, -0.16],
                    [-0.32, -0.1],
                    [-0.27, -0.11],
                    [-0.08, 0.09],
                    [-0.1, 0.34],
                    [0, 0],
                    [0, 0],
                    [0.01, 0.01],
                    [0.03, 0.02],
                    [1.39, 0.58],
                    [1.85, 0.34],
                    [1.88, 0.11],
                    [1.73, -0.11],
                    [0.57, -0.15],
                    [1.23, 0.44],
                    [0, 0],
                    [4.09, 0],
                    [1.28, -0.51],
                    [1.84, -1.48],
                    [0, 0],
                  ],
                  v: [
                    [49.3, 3.18],
                    [43.26, 0.01],
                    [36.03, 2.33],
                    [30.49, 5.81],
                    [30.45, 5.83],
                    [30.44, 5.79],
                    [19.41, 4.63],
                    [9.41, 7.35],
                    [4.24, 10.58],
                    [4.03, 10.79],
                    [1.92, 10.21],
                    [0.97, 9.86],
                    [0.2, 10.09],
                    [0.03, 10.39],
                    [0.33, 11.21],
                    [0.34, 11.21],
                    [0.44, 11.28],
                    [0.46, 11.29],
                    [0.56, 11.34],
                    [4.93, 12.53],
                    [10.54, 13.2],
                    [16.33, 13.21],
                    [21.47, 12.46],
                    [23.16, 11.9],
                    [32.26, 13.43],
                    [32.63, 13.43],
                    [43.53, 11.34],
                    [47.12, 9.37],
                    [49.3, 3.18],
                  ],
                },
              },
            },
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.71, -0.17],
                    [0.4, -0.08],
                    [0.2, -0.03],
                    [0.11, -0.02],
                    [0, 0],
                    [0, 0],
                    [1.91, 0.04],
                    [1, 0.08],
                    [0.49, 0.05],
                    [0.23, 0.03],
                    [0.29, 0.04],
                    [0.26, 0.04],
                    [-2.86, 0.87],
                    [-3.41, -0.29],
                    [-1.58, -0.35],
                    [2.13, -0.92],
                  ],
                  o: [
                    [-0.67, 0.29],
                    [-0.41, 0.1],
                    [-0.2, 0.03],
                    [-0.1, 0.02],
                    [0, 0],
                    [0, 0],
                    [-1.89, 0.23],
                    [-1.01, -0.02],
                    [-0.49, -0.05],
                    [-0.23, -0.03],
                    [-0.28, -0.04],
                    [-0.26, -0.04],
                    [2.45, -1.73],
                    [3.25, -0.99],
                    [1.61, 0.14],
                    [-1.92, 1.3],
                    [0, 0],
                  ],
                  v: [
                    [22.79, 10.41],
                    [20.7, 11.08],
                    [19.49, 11.33],
                    [18.89, 11.42],
                    [18.58, 11.47],
                    [18.55, 11.47],
                    [18.31, 11.5],
                    [12.59, 11.75],
                    [9.58, 11.6],
                    [8.1, 11.46],
                    [7.42, 11.38],
                    [6.79, 11.29],
                    [6.02, 11.17],
                    [13.98, 7.16],
                    [24, 6.2],
                    [28.79, 6.96],
                    [22.79, 10.41],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 19,
          parent: 17,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [2.44, 2.66] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [156.04, 39.39], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [160.34, 41.72], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [160.34, 41.72], t: 72 },
                { s: [156.04, 39.39], t: 132 },
              ],
            },
            r: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [14.16], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [14.16], t: 72 },
                { s: [0], t: 132 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.03, -0.08],
                    [1, 0.03],
                    [0, 0],
                    [0, -0.12],
                    [-0.13, -0.01],
                    [0, 0],
                    [0.02, -0.57],
                    [0.87, 0.02],
                    [0, 0],
                    [-0.01, 0.43],
                    [-0.47, 0.13],
                    [0, 0.21],
                    [-0.51, 0.11],
                    [0, 0.24],
                    [-1.06, -0.03],
                    [-0.23, -0.16],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0.05, 0.07],
                    [0.39, 1.01],
                    [0, 0],
                    [-0.12, 0],
                    [0, 0.08],
                    [0, 0],
                    [0.77, 0.02],
                    [-0.02, 0.63],
                    [0, 0],
                    [-0.73, -0.02],
                    [0.01, -0.36],
                    [-0.14, -0.15],
                    [0, -0.33],
                    [-0.17, -0.19],
                    [0.02, -0.66],
                    [0.37, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [4.88, 0.03],
                    [4.51, 0.91],
                    [3.88, 0.89],
                    [4, 1.12],
                    [2.5, 2.9],
                    [1.71, 2.88],
                    [1.49, 3.07],
                    [1.67, 3.22],
                    [2.65, 3.25],
                    [3.77, 4.18],
                    [2.37, 5.32],
                    [1.02, 5.28],
                    [0, 4.42],
                    [0.73, 3.6],
                    [0.52, 3.06],
                    [1.29, 2.31],
                    [1.06, 1.65],
                    [2.69, 0.39],
                    [3.6, 0.64],
                    [3.87, 0],
                    [4.87, 0.03],
                    [4.88, 0.03],
                  ],
                },
              },
            },
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, -0.14],
                    [-0.13, 0],
                    [0, 0],
                    [-0.01, 0.12],
                    [0.14, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.2, 0],
                    [0, 0.11],
                    [0, 0],
                    [0.18, 0],
                    [0, -0.11],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [1.41, 4.05],
                    [1.09, 4.28],
                    [1.3, 4.47],
                    [2.38, 4.5],
                    [2.69, 4.27],
                    [2.46, 4.09],
                    [1.41, 4.06],
                    [1.41, 4.05],
                  ],
                },
              },
            },
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.01, -0.22],
                    [-0.23, 0],
                    [-0.01, 0.22],
                    [0.24, 0],
                  ],
                  o: [
                    [-0.31, 0],
                    [0, 0.23],
                    [0.32, 0],
                    [0, -0.23],
                    [0, 0],
                  ],
                  v: [
                    [2.64, 1.24],
                    [2.14, 1.69],
                    [2.55, 2.06],
                    [3.05, 1.61],
                    [2.64, 1.24],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 2,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 20,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [1.93, 1.88] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [159.64, 39.1], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [163.9, 42.31], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [163.9, 42.31], t: 72 },
                { s: [159.64, 39.1], t: 132 },
              ],
            },
            r: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [14.16], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [14.16], t: 72 },
                { s: [0], t: 132 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [-0.03, 1.11],
                    [-1.28, -0.04],
                    [0.03, -1.12],
                    [1.28, 0.04],
                  ],
                  o: [
                    [-0.88, -0.02],
                    [0.03, -1.13],
                    [0.88, 0.02],
                    [-0.03, 1.13],
                    [0, 0],
                  ],
                  v: [
                    [1.69, 3.76],
                    [0, 2.11],
                    [2.16, 0],
                    [3.85, 1.65],
                    [1.69, 3.76],
                  ],
                },
              },
            },
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [-0.33, 0],
                    [-0.01, 0.49],
                    [0.33, 0],
                    [0.01, -0.49],
                  ],
                  o: [
                    [-0.01, 0.44],
                    [0.51, 0.01],
                    [0.01, -0.44],
                    [-0.51, -0.01],
                    [0, 0],
                  ],
                  v: [
                    [1.18, 2.08],
                    [1.76, 2.73],
                    [2.66, 1.68],
                    [2.08, 1.03],
                    [1.18, 2.08],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 21,
        },
        {
          ty: 4,
          nm: 'Group',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [15.18, 8.56] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [155.3, 41.58], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [159.09, 43.66], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [159.09, 43.66], t: 72 },
                { s: [155.3, 41.58], t: 132 },
              ],
            },
            r: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [14.16], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [14.16], t: 72 },
                { s: [0], t: 132 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [],
          ind: 22,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [15.18, 8.07] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [15.18, 8.07] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [3.71, -0.26],
                    [3.13, -1.54],
                    [1.62, -1.22],
                    [0.06, -0.08],
                    [0.69, 0.23],
                    [0.31, 0.13],
                    [0.2, -0.21],
                    [-3.83, 3.21],
                    [-5.12, -1.68],
                    [-1.54, -4.8],
                  ],
                  o: [
                    [-3.6, -0.92],
                    [-3.49, 0.25],
                    [-1.83, 0.9],
                    [-0.08, 0.06],
                    [-0.71, -0.16],
                    [-0.32, -0.1],
                    [-0.27, -0.11],
                    [-0.49, -4.8],
                    [4.13, -3.49],
                    [4.8, 1.56],
                    [0, 0],
                  ],
                  v: [
                    [30.36, 11.15],
                    [19.33, 9.99],
                    [9.33, 12.71],
                    [4.16, 15.94],
                    [3.95, 16.15],
                    [1.84, 15.57],
                    [0.89, 15.22],
                    [0.12, 15.45],
                    [4.44, 3.63],
                    [20.11, 0.79],
                    [30.36, 11.15],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 23,
          parent: 22,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [11.39, 2.84] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [17.32, 14.28] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [2.13, -0.92],
                    [0.71, -0.17],
                    [0.4, -0.08],
                    [0.2, -0.03],
                    [0.11, -0.02],
                    [0, 0],
                    [0, 0],
                    [1.91, 0.04],
                    [1, 0.08],
                    [0.49, 0.05],
                    [0.23, 0.03],
                    [0.29, 0.04],
                    [0.26, 0.04],
                    [-2.86, 0.87],
                    [-3.41, -0.29],
                    [-1.58, -0.35],
                  ],
                  o: [
                    [-1.92, 1.3],
                    [-0.67, 0.29],
                    [-0.41, 0.1],
                    [-0.2, 0.03],
                    [-0.1, 0.02],
                    [0, 0],
                    [0, 0],
                    [-1.89, 0.23],
                    [-1.01, -0.02],
                    [-0.49, -0.05],
                    [-0.23, -0.03],
                    [-0.28, -0.04],
                    [-0.26, -0.04],
                    [2.45, -1.73],
                    [3.25, -0.99],
                    [1.61, 0.14],
                    [0, 0],
                  ],
                  v: [
                    [22.77, 0.87],
                    [16.77, 4.32],
                    [14.68, 4.99],
                    [13.47, 5.24],
                    [12.87, 5.33],
                    [12.56, 5.38],
                    [12.53, 5.38],
                    [12.29, 5.41],
                    [6.57, 5.66],
                    [3.56, 5.51],
                    [2.08, 5.37],
                    [1.4, 5.29],
                    [0.77, 5.2],
                    [0, 5.08],
                    [7.96, 1.07],
                    [17.98, 0.11],
                    [22.77, 0.87],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 24,
          parent: 22,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [0.05, 0.03] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [0.31, 16.6] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.03, -0.02],
                  ],
                  o: [
                    [-0.07, -0.02],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.1, 0.07],
                    [0, 0.04],
                    [0, 0],
                    [0.1, 0.07],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 25,
          parent: 22,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [5.06, 3.38] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [93.84, 179.44] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [100], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 72 },
                { s: [100], t: 132 },
              ],
            },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.47, 0.1],
                    [-0.06, 0.3],
                    [-0.3, -0.07],
                    [-1.06, 2.62],
                    [-0.28, -0.12],
                    [0.11, -0.28],
                    [3.81, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.46, 0],
                    [-0.3, -0.06],
                    [0.06, -0.3],
                    [3.72, 0.8],
                    [0.12, -0.28],
                    [0.28, 0.11],
                    [-1.1, 2.72],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [1.83, 6.74],
                    [0.44, 6.59],
                    [0.01, 5.93],
                    [0.67, 5.51],
                    [9.05, 0.34],
                    [9.77, 0.04],
                    [10.08, 0.76],
                    [1.83, 6.75],
                    [1.83, 6.74],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 26,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [2.91, 4.45] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [47.93, 144.33] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [100], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 72 },
                { s: [100], t: 132 },
              ],
            },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.03, 0.28],
                    [-4.31, 1.29],
                    [-0.09, -0.29],
                    [0.29, -0.09],
                    [-0.33, -2.77],
                    [0.3, -0.04],
                    [0.03, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.28, 0],
                    [-0.37, -3.07],
                    [0.3, -0.09],
                    [0.09, 0.29],
                    [-3.65, 1.08],
                    [0.04, 0.3],
                    [-0.02, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.62, 8.9],
                    [0.07, 8.41],
                    [5.11, 0.02],
                    [5.8, 0.39],
                    [5.43, 1.08],
                    [1.17, 8.27],
                    [0.69, 8.89],
                    [0.62, 8.89],
                    [0.62, 8.9],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 27,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3.78, 5.89] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [52.58, 147.19] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [100], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 72 },
                { s: [100], t: 132 },
              ],
            },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.03, 0.28],
                    [-5.79, 1.71],
                    [-0.09, -0.29],
                    [0.29, -0.09],
                    [-0.47, -3.87],
                    [0.3, -0.04],
                    [0.03, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.28, 0],
                    [-0.5, -4.12],
                    [0.29, -0.09],
                    [0.09, 0.29],
                    [-5.12, 1.52],
                    [0.04, 0.3],
                    [-0.02, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.64, 11.77],
                    [0.09, 11.28],
                    [6.85, 0.02],
                    [7.54, 0.39],
                    [7.17, 1.08],
                    [1.2, 11.15],
                    [0.72, 11.77],
                    [0.65, 11.77],
                    [0.64, 11.77],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 28,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [16.33, 15.36] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [124.52, 134.24] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.31, 0.91],
                    [-1.16, 0.4],
                    [-0.11, 0.19],
                    [-1.08, -0.56],
                    [0.56, -1.08],
                    [18.43, -6.36],
                    [0.24, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.92, 0],
                    [-0.4, -1.16],
                    [16.74, -5.78],
                    [0.56, -1.08],
                    [1.09, 0.56],
                    [-0.44, 0.85],
                    [-0.24, 0.08],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [2.21, 30.73],
                    [0.12, 29.24],
                    [1.49, 26.42],
                    [28.47, 1.2],
                    [31.45, 0.25],
                    [32.4, 3.23],
                    [2.94, 30.6],
                    [2.22, 30.72],
                    [2.21, 30.73],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 29,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [17.76, 14.34] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [107.6, 125.54] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.27, 0.99],
                    [-1.18, 0.31],
                    [-0.12, 0.19],
                    [-1.03, -0.67],
                    [0.67, -1.02],
                    [19.11, -5.11],
                    [0.19, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.98, 0],
                    [-0.32, -1.18],
                    [17.45, -4.66],
                    [0.67, -1.02],
                    [1.02, 0.67],
                    [-0.53, 0.82],
                    [-0.19, 0.05],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [2.22, 28.66],
                    [0.08, 27.02],
                    [1.65, 24.31],
                    [31.46, 1],
                    [34.53, 0.36],
                    [35.17, 3.42],
                    [2.8, 28.59],
                    [2.23, 28.67],
                    [2.22, 28.66],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 30,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [1.44, 4.04] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [102.8, 145.27] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.07, 0.25],
                    [-1.79, 1.65],
                    [-0.21, -0.22],
                    [0.22, -0.2],
                    [-0.67, -2.56],
                    [0.3, -0.08],
                    [0.05, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.25, 0],
                    [-0.79, -3],
                    [0.23, -0.21],
                    [0.21, 0.22],
                    [-1.46, 1.35],
                    [0.08, 0.3],
                    [-0.05, 0.01],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.88, 8.09],
                    [0.34, 7.68],
                    [1.96, 0.15],
                    [2.74, 0.18],
                    [2.71, 0.96],
                    [1.41, 7.39],
                    [1.01, 8.07],
                    [0.87, 8.09],
                    [0.88, 8.09],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 31,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3.48, 1.53] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [108.12, 154.67] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [1.49, 1.36],
                    [-0.2, 0.22],
                    [-0.22, -0.2],
                    [-1.66, 0.5],
                    [-0.09, -0.29],
                    [0.29, -0.09],
                    [0.52, 0],
                  ],
                  o: [
                    [-1.64, 0],
                    [-0.23, -0.21],
                    [0.21, -0.23],
                    [1.67, 1.52],
                    [0.29, -0.09],
                    [0.09, 0.29],
                    [-0.49, 0.15],
                    [0, 0],
                  ],
                  v: [
                    [5.05, 3.05],
                    [0.18, 0.96],
                    [0.14, 0.18],
                    [0.92, 0.14],
                    [6.24, 1.77],
                    [6.93, 2.14],
                    [6.56, 2.83],
                    [5.05, 3.05],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 32,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [2.67, 4.48] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [86.84, 134.21] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.06, 0.26],
                    [-2.54, 1.27],
                    [-0.55, 0.07],
                    [-0.04, -0.3],
                    [0.3, -0.04],
                    [0.4, -0.2],
                    [-0.7, -3.03],
                    [0.29, -0.07],
                    [0.05, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.25, 0],
                    [-0.83, -3.54],
                    [0.51, -0.25],
                    [0.31, -0.04],
                    [0.04, 0.3],
                    [-0.43, 0.05],
                    [-2.07, 1.03],
                    [0.07, 0.3],
                    [-0.04, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.81, 8.95],
                    [0.27, 8.52],
                    [3.13, 0.48],
                    [4.72, 0],
                    [5.34, 0.48],
                    [4.86, 1.1],
                    [3.62, 1.48],
                    [1.34, 8.28],
                    [0.93, 8.95],
                    [0.8, 8.96],
                    [0.81, 8.95],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 33,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [4.66, 2.42] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [92.98, 143.41] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [1.27, 0.89],
                    [-0.17, 0.25],
                    [-0.25, -0.17],
                    [-1.51, 0.75],
                    [-0.38, 1.37],
                    [-0.29, -0.08],
                    [0.09, -0.29],
                    [1.36, -0.68],
                    [0.8, 0],
                    [0, 0],
                  ],
                  o: [
                    [-1.3, 0],
                    [-0.25, -0.17],
                    [0.18, -0.25],
                    [1.74, 1.21],
                    [1.09, -0.54],
                    [0.08, -0.29],
                    [0.29, 0.08],
                    [-0.46, 1.66],
                    [-0.71, 0.35],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [4.19, 4.85],
                    [0.24, 3.51],
                    [0.1, 2.74],
                    [0.87, 2.6],
                    [5.98, 3.33],
                    [8.24, 0.4],
                    [8.92, 0.02],
                    [9.3, 0.7],
                    [6.47, 4.32],
                    [4.19, 4.84],
                    [4.19, 4.85],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 34,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [6.8, 4.78] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [70.86, 154.81] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [-0.01, 0.3],
                    [2.2, 1.43],
                    [2.47, -0.7],
                    [0.08, 0.29],
                    [-0.29, 0.08],
                    [-2.56, -1.67],
                    [0.1, -2.65],
                    [0.29, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-0.31, -0.01],
                    [0.08, -2.23],
                    [-2.27, -1.48],
                    [-0.29, 0.08],
                    [-0.08, -0.29],
                    [2.8, -0.79],
                    [2.55, 1.66],
                    [-0.01, 0.3],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [13.03, 9.54],
                    [13.01, 9.54],
                    [12.48, 8.97],
                    [8.88, 2.75],
                    [0.7, 1.4],
                    [0.02, 1.02],
                    [0.4, 0.34],
                    [9.49, 1.83],
                    [13.59, 9.02],
                    [13.04, 9.55],
                    [13.03, 9.54],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 35,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [5.51, 5.12] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [89.26, 165.49] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.03, 0],
                    [-0.05, 0.3],
                    [1.65, 1.55],
                    [2.49, -0.31],
                    [0.04, 0.3],
                    [-0.3, 0.04],
                    [-1.91, -1.79],
                    [0.34, -2.14],
                    [0.27, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-0.3, -0.05],
                    [0.29, -1.81],
                    [-1.66, -1.56],
                    [-0.3, 0.04],
                    [-0.04, -0.3],
                    [2.83, -0.35],
                    [1.94, 1.82],
                    [-0.04, 0.27],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [10.41, 10.23],
                    [10.32, 10.23],
                    [9.86, 9.6],
                    [7.78, 3.33],
                    [0.62, 1.17],
                    [0, 0.69],
                    [0.48, 0.07],
                    [8.53, 2.52],
                    [10.94, 9.77],
                    [10.39, 10.24],
                    [10.41, 10.23],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 36,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [5.97, 6.88] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [81, 172.04] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [1.66, 3.77],
                    [-0.31, 2.11],
                    [-0.3, -0.04],
                    [0.05, -0.3],
                    [-0.97, -2.22],
                    [-3.76, 0.19],
                    [-0.01, -0.3],
                    [0.3, -0.01],
                    [0.17, 0],
                    [0, 0],
                  ],
                  o: [
                    [-4.08, 0],
                    [-1.06, -2.4],
                    [0.05, -0.3],
                    [0.3, 0.05],
                    [-0.29, 1.91],
                    [1.52, 3.46],
                    [0.32, -0.02],
                    [0.02, 0.31],
                    [-0.17, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [10.91, 13.77],
                    [1.25, 7.47],
                    [0.1, 0.47],
                    [0.73, 0.01],
                    [1.19, 0.64],
                    [2.25, 7.03],
                    [11.35, 12.66],
                    [11.93, 13.18],
                    [11.41, 13.76],
                    [10.89, 13.77],
                    [10.91, 13.77],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 37,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [13.62, 12.87] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [70.96, 141.66] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.04, 0.01],
                    [-0.07, 0.3],
                    [-1.15, 1.52],
                    [-2.86, 1.79],
                    [-2.03, 2.15],
                    [-0.63, 0.82],
                    [-0.52, 0.61],
                    [-1.63, 0.56],
                    [-0.33, 0.07],
                    [-0.06, -0.3],
                    [0.3, -0.06],
                    [0.28, -0.09],
                    [1.33, -1.57],
                    [0.46, -0.61],
                    [0.75, -0.81],
                    [2.42, -1.52],
                    [2.1, -2.78],
                    [0.37, -1.71],
                    [0.25, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-0.3, -0.07],
                    [0.41, -1.86],
                    [2.23, -2.95],
                    [2.36, -1.48],
                    [0.71, -0.76],
                    [0.47, -0.62],
                    [1.45, -1.72],
                    [0.34, -0.12],
                    [0.31, -0.05],
                    [0.06, 0.3],
                    [-0.28, 0.05],
                    [-1.45, 0.5],
                    [-0.5, 0.58],
                    [-0.64, 0.85],
                    [-2.12, 2.25],
                    [-2.9, 1.82],
                    [-1.05, 1.39],
                    [-0.06, 0.26],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.55, 25.75],
                    [0.43, 25.74],
                    [0.01, 25.08],
                    [2.39, 19.92],
                    [10.43, 13.33],
                    [17.26, 8.17],
                    [19.25, 5.73],
                    [20.72, 3.86],
                    [25.57, 0.28],
                    [26.58, 0.01],
                    [27.23, 0.45],
                    [26.79, 1.1],
                    [25.94, 1.32],
                    [21.57, 4.57],
                    [20.14, 6.39],
                    [18.08, 8.93],
                    [11.03, 14.27],
                    [3.29, 20.59],
                    [1.11, 25.32],
                    [0.57, 25.75],
                    [0.55, 25.75],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 38,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [18.21, 12.28] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [76.31, 156.78] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [1.49, 2.57],
                    [-0.26, 0.16],
                    [-0.16, -0.26],
                    [-3.67, 1.04],
                    [-2.01, 3.22],
                    [0, 0],
                    [-1.03, 1.05],
                    [-1.32, 0.88],
                    [-0.26, 0.18],
                    [-1.13, 3.29],
                    [-0.29, -0.09],
                    [0.09, -0.29],
                    [3.14, -2.16],
                    [0.3, -0.2],
                    [0.91, -0.91],
                    [0.72, -1.16],
                    [0, 0],
                    [6.13, -1.74],
                    [0.62, 0],
                    [0, 0],
                  ],
                  o: [
                    [-3.96, 0],
                    [-0.15, -0.26],
                    [0.26, -0.15],
                    [1.54, 2.65],
                    [5.76, -1.63],
                    [0, 0],
                    [0.75, -1.21],
                    [0.99, -1],
                    [0.3, -0.2],
                    [3.01, -2.07],
                    [0.1, -0.29],
                    [0.29, 0.1],
                    [-1.22, 3.57],
                    [-0.26, 0.18],
                    [-1.21, 0.81],
                    [-0.95, 0.96],
                    [0, 0],
                    [-2.12, 3.39],
                    [-0.6, 0.17],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [9.84, 24.55],
                    [0.07, 18.89],
                    [0.27, 18.13],
                    [1.03, 18.33],
                    [11.38, 23.24],
                    [22.2, 14.48],
                    [22.28, 14.35],
                    [24.84, 10.84],
                    [28.64, 7.96],
                    [29.48, 7.39],
                    [35.35, 0.38],
                    [36.05, 0.03],
                    [36.4, 0.73],
                    [30.11, 8.3],
                    [29.26, 8.88],
                    [25.63, 11.62],
                    [23.22, 14.94],
                    [23.14, 15.07],
                    [11.68, 24.31],
                    [9.84, 24.56],
                    [9.84, 24.55],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 39,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [21.71, 20.24] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [92.85, 159.74] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [2.65, -0.35],
                    [1.99, -0.37],
                    [2.59, -1.67],
                    [1.33, -1.31],
                    [3.06, -2.33],
                    [-1.32, -6.06],
                    [-2.31, -1.85],
                    [-2.06, 1.61],
                    [-1.04, 0.47],
                    [-2.03, 3.26],
                    [-1.02, 1.05],
                    [-1.38, 0.94],
                    [-1.14, 3.33],
                    [-0.18, 0.09],
                    [-0.41, 1.44],
                    [1.09, 2.21],
                    [0, 0],
                  ],
                  o: [
                    [-1.63, -3.29],
                    [-1.16, -0.66],
                    [-0.91, -0.45],
                    [-1.86, 1.2],
                    [-4.82, 4.76],
                    [-5.6, 4.27],
                    [0.53, 2.46],
                    [3.73, 2.97],
                    [1.13, -0.09],
                    [3.51, -1.56],
                    [0.77, -1.24],
                    [1.17, -1.19],
                    [3.24, -2.22],
                    [0.19, -0.07],
                    [1.26, -0.63],
                    [0.54, -1.88],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [42.36, 6.25],
                    [35.03, 1.39],
                    [30.09, 0.44],
                    [23.16, 1.15],
                    [17.85, 6.37],
                    [7.55, 13.89],
                    [0.31, 31.19],
                    [4.54, 38.06],
                    [15.69, 39.39],
                    [18.98, 38.57],
                    [26.83, 30.38],
                    [29.4, 26.83],
                    [33.97, 23.44],
                    [40.05, 16.15],
                    [40.61, 15.92],
                    [43.14, 12.69],
                    [42.37, 6.25],
                    [42.36, 6.25],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 40,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [21.71, 20.24] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [75.65, 149.14] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [2.65, -0.35],
                    [1.99, -0.37],
                    [2.59, -1.67],
                    [1.33, -1.31],
                    [3.06, -2.33],
                    [-1.32, -6.06],
                    [-2.31, -1.85],
                    [-2.06, 1.61],
                    [-1.04, 0.47],
                    [-2.03, 3.26],
                    [-1.02, 1.05],
                    [-1.38, 0.94],
                    [-1.14, 3.33],
                    [-0.18, 0.09],
                    [-0.41, 1.44],
                    [1.09, 2.21],
                    [0, 0],
                  ],
                  o: [
                    [-1.63, -3.29],
                    [-1.16, -0.66],
                    [-0.91, -0.45],
                    [-1.86, 1.2],
                    [-4.82, 4.76],
                    [-5.6, 4.27],
                    [0.53, 2.46],
                    [3.73, 2.97],
                    [1.13, -0.09],
                    [3.51, -1.56],
                    [0.77, -1.24],
                    [1.17, -1.19],
                    [3.24, -2.22],
                    [0.19, -0.07],
                    [1.26, -0.63],
                    [0.54, -1.88],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [42.36, 6.25],
                    [35.03, 1.39],
                    [30.09, 0.44],
                    [23.16, 1.15],
                    [17.85, 6.37],
                    [7.55, 13.89],
                    [0.31, 31.19],
                    [4.54, 38.06],
                    [15.69, 39.39],
                    [18.98, 38.57],
                    [26.83, 30.38],
                    [29.4, 26.83],
                    [33.97, 23.44],
                    [40.05, 16.15],
                    [40.61, 15.92],
                    [43.14, 12.69],
                    [42.37, 6.25],
                    [42.36, 6.25],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 41,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [6.56, 1.7] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [166.33, 68.7] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.1, 0.1],
                    [6.08, -4.02],
                    [0.17, 0.26],
                    [-0.26, 0.17],
                    [-0.06, -0.05],
                    [0.2, -0.23],
                    [0.16, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.13, 0],
                    [-0.21, -0.18],
                    [-0.26, 0.17],
                    [-0.17, -0.26],
                    [6.79, -4.49],
                    [0.23, 0.2],
                    [-0.11, 0.13],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [12.56, 3.39],
                    [12.2, 3.25],
                    [0.86, 2.8],
                    [0.09, 2.64],
                    [0.25, 1.87],
                    [12.93, 2.41],
                    [12.98, 3.19],
                    [12.56, 3.38],
                    [12.56, 3.39],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 42,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [6.45, 2.19] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [143.89, 62.53] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.11, 0.1],
                    [-0.21, 0.22],
                    [-0.07, -0.03],
                    [0.14, -0.27],
                    [0.27, 0.14],
                    [5, -5.31],
                    [0.14, 0],
                  ],
                  o: [
                    [-0.14, 0],
                    [-0.22, -0.21],
                    [5.59, -5.93],
                    [0.27, 0.14],
                    [-0.14, 0.27],
                    [-0.25, -0.13],
                    [-0.11, 0.12],
                    [0, 0],
                  ],
                  v: [
                    [0.55, 4.38],
                    [0.17, 4.23],
                    [0.15, 3.45],
                    [12.61, 1.06],
                    [12.84, 1.81],
                    [12.09, 2.04],
                    [0.95, 4.21],
                    [0.55, 4.38],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 43,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [2.9, 3.87] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [128.77, 87.19] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [1.39, 0.54],
                    [0.81, -2.07],
                    [-1.38, -0.54],
                    [-0.81, 2.07],
                  ],
                  o: [
                    [0.81, -2.07],
                    [-1.38, -0.54],
                    [-0.81, 2.07],
                    [1.38, 0.54],
                    [0, 0],
                  ],
                  v: [
                    [5.4, 4.86],
                    [4.37, 0.13],
                    [0.4, 2.89],
                    [1.43, 7.62],
                    [5.4, 4.86],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 44,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [2.9, 3.88] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [167.5, 101.61] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [1.38, 0.54],
                    [0.81, -2.07],
                    [-1.38, -0.55],
                    [-0.81, 2.07],
                    [0, 0],
                  ],
                  o: [
                    [0.81, -2.07],
                    [-1.38, -0.54],
                    [-0.81, 2.07],
                    [1.38, 0.54],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [5.4, 4.86],
                    [4.37, 0.13],
                    [0.4, 2.89],
                    [1.43, 7.63],
                    [5.4, 4.87],
                    [5.4, 4.86],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 45,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [5.15, 7.41] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [147.41, 73.2] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [-0.81, 1.98],
                    [0, 0],
                    [-2.98, -1.22],
                    [2.29, -5.84],
                    [1.35, 0.65],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0.76, -1.88],
                    [0, 0],
                    [1.84, 0.76],
                    [-2.07, 5.27],
                    [-4.27, -2.05],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [1.59, 5.2],
                    [6.78, 6.24],
                    [2.31, 3.43],
                    [7.56, 0.21],
                    [9.32, 9.35],
                    [2.01, 14.61],
                    [1.6, 5.19],
                    [1.59, 5.2],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 46,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [7.69, 11.16] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [143.63, 76.75] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [3.76, 1.23],
                    [1.96, -6.04],
                    [-3.76, -1.23],
                    [-1.97, 6.04],
                  ],
                  o: [
                    [1.96, -6.04],
                    [-3.76, -1.23],
                    [-1.96, 6.04],
                    [3.76, 1.23],
                    [0, 0],
                  ],
                  v: [
                    [14.5, 13.38],
                    [11.24, 0.23],
                    [0.87, 8.94],
                    [4.13, 22.09],
                    [14.5, 13.38],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.9687, 0.9687, 0.9687] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 47,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [5.15, 7.41] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [165.99, 79.98] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [-0.81, 1.98],
                    [0, 0],
                    [-2.98, -1.22],
                    [2.29, -5.84],
                    [1.34, 0.65],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0.76, -1.88],
                    [0, 0],
                    [1.84, 0.76],
                    [-2.07, 5.27],
                    [-4.27, -2.06],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [1.59, 5.2],
                    [6.78, 6.24],
                    [2.31, 3.43],
                    [7.56, 0.21],
                    [9.32, 9.35],
                    [2.01, 14.61],
                    [1.6, 5.19],
                    [1.59, 5.2],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 48,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [7.69, 11.16] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [162.2, 83.53] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [3.76, 1.23],
                    [1.96, -6.04],
                    [-3.76, -1.23],
                    [-1.97, 6.04],
                  ],
                  o: [
                    [1.96, -6.04],
                    [-3.76, -1.23],
                    [-1.96, 6.04],
                    [3.76, 1.23],
                    [0, 0],
                  ],
                  v: [
                    [14.5, 13.38],
                    [11.24, 0.23],
                    [0.87, 8.94],
                    [4.13, 22.09],
                    [14.5, 13.38],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.9687, 0.9687, 0.9687] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 49,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3.53, 5.24] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [150.58, 91.9] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [4.09, 1.46],
                    [-0.11, 0.29],
                    [-0.29, -0.1],
                    [-1.11, -0.36],
                    [-0.08, 0.17],
                    [-0.28, -0.12],
                    [0.12, -0.28],
                    [-4.56, -4.68],
                    [0, 0],
                    [0, 0],
                    [0.28, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.56, 0],
                    [-0.29, -0.1],
                    [0.1, -0.29],
                    [1.41, 0.51],
                    [-3.59, -4.65],
                    [0.13, -0.28],
                    [0.28, 0.13],
                    [-0.08, 0.17],
                    [0, 0],
                    [0, 0],
                    [-0.09, 0.16],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [6.41, 10.48],
                    [0.37, 8.56],
                    [0.04, 7.85],
                    [0.75, 7.52],
                    [4.78, 8.91],
                    [2.89, 0.33],
                    [3.62, 0.05],
                    [3.9, 0.78],
                    [6.76, 9.5],
                    [7.06, 9.8],
                    [6.87, 10.2],
                    [6.43, 10.48],
                    [6.41, 10.48],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 50,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [14.84, 9.19] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [145.57, 102.5] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.71, 0.06],
                    [2.95, 2.58],
                    [-0.13, 3.4],
                    [-1.15, 0.85],
                    [-1.22, -0.33],
                    [-1.28, -1.51],
                    [-0.63, -0.66],
                    [-3.22, 0.3],
                    [-1.87, -2.08],
                    [1.68, -1.56],
                    [4.14, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.62, 0],
                    [-4.56, -0.33],
                    [-2.17, -1.71],
                    [0.05, -1.31],
                    [1.04, -0.76],
                    [2.13, 0.58],
                    [0.45, 0.53],
                    [2.19, 2.29],
                    [2.98, -0.27],
                    [1.81, 2.01],
                    [-1.05, 0.97],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [20.82, 18.38],
                    [18.82, 18.3],
                    [4.62, 12.26],
                    [0, 4.37],
                    [1.98, 0.81],
                    [5.48, 0.14],
                    [9.82, 3.32],
                    [11.4, 5.1],
                    [20.04, 8.29],
                    [28.58, 9.77],
                    [28.11, 16.35],
                    [20.83, 18.38],
                    [20.82, 18.38],
                  ],
                },
              },
            },
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.4, -0.3],
                    [0.04, -0.97],
                    [-1.98, -1.58],
                    [-4.35, -0.32],
                    [-1.47, 1.37],
                    [1.35, 1.5],
                    [3.35, -0.3],
                    [2.43, 2.53],
                    [0.45, 0.54],
                    [1.8, 0.49],
                    [0.25, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.76, 0],
                    [-0.88, 0.65],
                    [-0.11, 2.93],
                    [2.83, 2.48],
                    [3.98, 0.29],
                    [1.27, -1.18],
                    [-1.39, -1.53],
                    [-3.54, 0.32],
                    [-0.65, -0.68],
                    [-1.24, -1.46],
                    [-0.28, -0.08],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [4.4, 1.11],
                    [2.64, 1.71],
                    [1.11, 4.42],
                    [5.33, 11.42],
                    [18.9, 17.21],
                    [27.35, 15.54],
                    [27.75, 10.51],
                    [20.13, 9.4],
                    [10.59, 5.87],
                    [8.97, 4.04],
                    [5.19, 1.21],
                    [4.4, 1.1],
                    [4.4, 1.11],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 51,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [4.69, 0.56] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [135.74, 98.93] },
            r: { a: 0, k: -64.2 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [9.39, 0],
                    [0, 0],
                    [0, 1.11],
                    [9.39, 1.11],
                    [9.39, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 52,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [4.57, 0.56] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [139.64, 102.51] },
            r: { a: 0, k: -66.64 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [9.15, 0],
                    [0, 0],
                    [0, 1.11],
                    [9.15, 1.11],
                    [9.15, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 53,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [4.17, 0.56] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [144.49, 105.25] },
            r: { a: 0, k: -69.23 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [8.34, 0],
                    [0, 0],
                    [0, 1.11],
                    [8.34, 1.11],
                    [8.34, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 54,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [4.61, 0.56] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [149.68, 106.39] },
            r: { a: 0, k: -72.01 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [9.23, 0],
                    [0, 0],
                    [0, 1.11],
                    [9.23, 1.11],
                    [9.23, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 55,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [4.68, 0.56] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [154.77, 106.43] },
            r: { a: 0, k: -72.65 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [9.37, 0],
                    [0, 0],
                    [0, 1.11],
                    [9.37, 1.11],
                    [9.37, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 56,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [14.28, 8.64] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [145.56, 102.5] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [3.29, -0.29],
                    [2.39, 2.49],
                    [2.68, 0.72],
                    [0.07, -1.93],
                    [-2.47, -1.96],
                    [-4.57, -0.34],
                    [-1.43, 1.32],
                    [1.62, 1.79],
                    [0, 0],
                  ],
                  o: [
                    [-1.61, -1.79],
                    [-3.29, 0.3],
                    [-2.39, -2.49],
                    [-2.68, -0.72],
                    [-0.11, 2.91],
                    [2.76, 2.42],
                    [4.57, 0.33],
                    [1.43, -1.32],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [27.61, 9.59],
                    [19.53, 8.29],
                    [10.44, 4.93],
                    [4.78, 0.13],
                    [0, 3.85],
                    [4.43, 11.3],
                    [18.3, 17.21],
                    [27.17, 15.4],
                    [27.6, 9.59],
                    [27.61, 9.59],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.9687, 0.9687, 0.9687] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 57,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3.96, 2.18] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [105.32, 103.95] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.09, 0.2],
                    [-0.27, 0.13],
                    [0, 0],
                    [-0.13, -0.27],
                    [0.27, -0.13],
                    [0, 0],
                    [0.08, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.21, 0],
                    [-0.13, -0.28],
                    [0, 0],
                    [0.28, -0.13],
                    [0.13, 0.28],
                    [0, 0],
                    [-0.08, 0.04],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.55, 4.35],
                    [0.05, 4.03],
                    [0.31, 3.29],
                    [7.12, 0.05],
                    [7.86, 0.31],
                    [7.6, 1.05],
                    [0.79, 4.29],
                    [0.55, 4.34],
                    [0.55, 4.35],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 58,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [6.47, 13.72] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [106.83, 98.19] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.08, 0.03],
                    [0, 0],
                    [-0.12, 0.27],
                    [0, 0],
                    [-0.27, -0.13],
                    [0.12, -0.27],
                    [0, 0],
                    [0, 0],
                    [0.13, -0.27],
                    [0.2, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.08, 0],
                    [0, 0],
                    [-0.26, -0.12],
                    [0, 0],
                    [0.12, -0.27],
                    [0.27, 0.12],
                    [0, 0],
                    [0, 0],
                    [0.26, 0.13],
                    [-0.09, 0.19],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [12.41, 27.42],
                    [12.18, 27.37],
                    [0.3, 21.7],
                    [0.05, 21],
                    [9.42, 0.31],
                    [10.12, 0.05],
                    [10.38, 0.75],
                    [1.23, 20.97],
                    [12.64, 26.42],
                    [12.89, 27.13],
                    [12.41, 27.43],
                    [12.41, 27.42],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 59,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [2.47, 4.84] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [117.24, 69.56] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.07, 0.03],
                    [-0.12, 0.27],
                    [0, 0],
                    [-0.27, -0.13],
                    [0.12, -0.27],
                    [0, 0],
                    [0.2, 0],
                  ],
                  o: [
                    [-0.07, 0],
                    [-0.27, -0.12],
                    [0, 0],
                    [0.12, -0.27],
                    [0.27, 0.12],
                    [0, 0],
                    [-0.09, 0.2],
                    [0, 0],
                  ],
                  v: [
                    [0.53, 9.67],
                    [0.31, 9.62],
                    [0.05, 8.92],
                    [3.94, 0.31],
                    [4.64, 0.05],
                    [4.9, 0.75],
                    [1.01, 9.36],
                    [0.53, 9.67],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 60,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [25.44, 38.1] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [136.56, 87.8] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.08, 0.03],
                    [0, 0],
                    [-0.12, 0.27],
                    [0, 0],
                    [-0.26, -0.12],
                    [0.12, -0.27],
                    [0, 0],
                    [0, 0],
                    [0.13, -0.27],
                    [0.2, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.08, 0],
                    [0, 0],
                    [-0.26, -0.12],
                    [0, 0],
                    [0.12, -0.27],
                    [0.27, 0.12],
                    [0, 0],
                    [0, 0],
                    [0.26, 0.13],
                    [-0.09, 0.19],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [50.34, 76.19],
                    [50.11, 76.14],
                    [0.3, 52.37],
                    [0.05, 51.67],
                    [23.3, 0.31],
                    [24, 0.05],
                    [24.26, 0.75],
                    [1.23, 51.64],
                    [50.57, 75.19],
                    [50.82, 75.9],
                    [50.34, 76.2],
                    [50.34, 76.19],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 61,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [44.02, 41.29] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [144.46, 89.53] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, 57.61],
                    [53.71, 82.58],
                    [63.29, 78.2],
                    [88.04, 24.76],
                    [34.79, 0],
                    [24.99, 3.66],
                    [0, 57.61],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 62,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [0.98, 2.31] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [172.06, 148.93] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.04, 0.28],
                    [0, 0],
                    [0.06, 0.27],
                    [0.4, 1.04],
                    [-0.29, 0.1],
                    [-0.1, -0.28],
                    [-0.09, -0.44],
                    [-0.04, -0.29],
                    [0, 0],
                    [0.31, -0.04],
                    [0.02, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.27, 0],
                    [0, 0],
                    [-0.03, -0.26],
                    [-0.08, -0.4],
                    [-0.11, -0.29],
                    [0.28, -0.11],
                    [0.43, 1.12],
                    [0.06, 0.3],
                    [0, 0],
                    [0.04, 0.3],
                    [-0.03, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [1.42, 4.62],
                    [0.87, 4.14],
                    [0.83, 3.81],
                    [0.71, 3.01],
                    [0.04, 0.75],
                    [0.36, 0.04],
                    [1.07, 0.36],
                    [1.79, 2.81],
                    [1.92, 3.69],
                    [1.96, 4],
                    [1.48, 4.62],
                    [1.41, 4.62],
                    [1.42, 4.62],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 63,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [5.51, 3.09] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [163.78, 140.08] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.11, 0.14],
                    [2.45, -0.09],
                    [0.01, 0.3],
                    [-0.3, 0.01],
                    [-3.66, -4.53],
                    [0.24, -0.19],
                    [0.12, 0],
                  ],
                  o: [
                    [-0.16, 0],
                    [-3.37, -4.18],
                    [-0.31, -0.01],
                    [-0.01, -0.3],
                    [2.71, -0.11],
                    [0.19, 0.24],
                    [-0.1, 0.08],
                    [0, 0],
                  ],
                  v: [
                    [10.46, 6.18],
                    [10.03, 5.97],
                    [0.57, 1.11],
                    [0, 0.58],
                    [0.53, 0.01],
                    [10.89, 5.28],
                    [10.81, 6.06],
                    [10.46, 6.18],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 64,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [1.98, 3.06] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [174.37, 161.28] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [100], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 72 },
                { s: [100], t: 132 },
              ],
            },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.11, 0.1],
                    [-0.21, 0.22],
                    [-0.01, 0.03],
                    [-0.3, -0.05],
                    [0.05, -0.3],
                    [2.58, -2.72],
                    [0.14, 0],
                  ],
                  o: [
                    [-0.14, 0],
                    [-0.22, -0.21],
                    [2.32, -2.45],
                    [0.05, -0.3],
                    [0.3, 0.05],
                    [-0.02, 0.1],
                    [-0.11, 0.12],
                    [0, 0],
                  ],
                  v: [
                    [0.55, 6.12],
                    [0.17, 5.97],
                    [0.15, 5.19],
                    [2.86, 0.47],
                    [3.49, 0.01],
                    [3.95, 0.64],
                    [0.95, 5.95],
                    [0.55, 6.12],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 65,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [6.5, 6.94] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [149.75, 149.46] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.01, 0.29],
                    [-8.23, 5.53],
                    [-0.17, -0.25],
                    [0.25, -0.17],
                    [-0.15, -2.77],
                    [0.3, -0.01],
                    [0.01, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.29, 0],
                    [-0.18, -3.27],
                    [0.26, -0.17],
                    [0.17, 0.25],
                    [-7.66, 5.15],
                    [0.02, 0.31],
                    [-0.01, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.56, 13.87],
                    [0.01, 13.35],
                    [12.15, 0.09],
                    [12.92, 0.24],
                    [12.77, 1.01],
                    [1.12, 13.29],
                    [0.6, 13.87],
                    [0.57, 13.87],
                    [0.56, 13.87],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 66,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3.39, 2.53] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [152.01, 158.86] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.06, 0.25],
                    [-0.3, 0.07],
                    [-1.3, 1.86],
                    [-0.25, -0.17],
                    [0.17, -0.25],
                    [2.36, -0.58],
                    [0.04, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.25, 0],
                    [-0.07, -0.3],
                    [2.1, -0.51],
                    [0.17, -0.25],
                    [0.25, 0.17],
                    [-1.45, 2.08],
                    [-0.04, 0.01],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.56, 5.07],
                    [0.02, 4.65],
                    [0.43, 3.98],
                    [5.78, 0.24],
                    [6.55, 0.1],
                    [6.69, 0.87],
                    [0.7, 5.05],
                    [0.57, 5.07],
                    [0.56, 5.07],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 67,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3.16, 2.42] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [158.27, 162.17] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.07, 0.25],
                    [-0.3, 0.07],
                    [-1.3, 1.87],
                    [-0.25, -0.18],
                    [0.17, -0.25],
                    [2.33, -0.59],
                    [0.05, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.25, 0],
                    [-0.07, -0.3],
                    [2.05, -0.52],
                    [0.17, -0.25],
                    [0.25, 0.17],
                    [-1.46, 2.11],
                    [-0.05, 0.01],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.56, 4.83],
                    [0.02, 4.41],
                    [0.42, 3.74],
                    [5.32, 0.24],
                    [6.09, 0.1],
                    [6.23, 0.87],
                    [0.69, 4.82],
                    [0.55, 4.84],
                    [0.56, 4.83],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 68,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [15.32, 15.19] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [158.71, 150.49] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [-0.15, 1.02],
                    [1.34, 2.11],
                    [0.46, 0.51],
                    [2.85, -0.27],
                    [0.7, -0.96],
                    [0, 0],
                    [0, 0],
                    [4.37, -3.51],
                    [0.65, -1.03],
                    [0, 0],
                    [-0.9, -0.56],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.56, -0.55],
                    [0, 0],
                    [0, 0],
                    [-0.16, -0.24],
                    [-0.14, -0.16],
                    [-1.57, 0.58],
                    [0, 0],
                    [0, 0],
                    [-3.1, 1.26],
                    [-1.39, 3.55],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0.47, -0.69],
                    [0.3, -2.2],
                    [-0.36, -0.57],
                    [-2.18, -2.43],
                    [-1.68, 0.16],
                    [0, 0],
                    [0, 0],
                    [-4.42, -0.61],
                    [-1.15, 0.92],
                    [0, 0],
                    [-1.93, 3.1],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-2.89, 4.22],
                    [2.17, 2.16],
                    [0, 0],
                    [0.13, 0.29],
                    [0.12, 0.18],
                    [1.21, 1.42],
                    [0, 0],
                    [0, 0],
                    [1.89, 1.95],
                    [3.02, -1.4],
                    [1.39, -3.55],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [28.97, 15.35],
                    [29.63, 14.37],
                    [30.56, 11.75],
                    [28.95, 5.07],
                    [27.71, 3.44],
                    [19.8, 0.04],
                    [16.39, 2.11],
                    [16.1, 2.5],
                    [15.63, 2.43],
                    [4.81, 5.94],
                    [1.4, 9.56],
                    [1.1, 10.04],
                    [1.08, 15.59],
                    [1.38, 15.81],
                    [1.94, 16.21],
                    [1.63, 16.83],
                    [1.37, 23.77],
                    [5.53, 24.96],
                    [5.78, 25.54],
                    [6.2, 26.33],
                    [6.58, 26.84],
                    [11.8, 28.41],
                    [12.29, 28.23],
                    [12.66, 28.6],
                    [20.42, 29.66],
                    [27.61, 21.56],
                    [28.97, 15.34],
                    [28.97, 15.35],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 69,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [10.99, 26.38] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [166.13, 126.63] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0.22, 1.04],
                    [-1.2, 0.25],
                    [-2.69, 9],
                    [8.62, 8.67],
                    [-0.86, 0.86],
                    [-0.86, -0.86],
                    [1.97, -6.58],
                    [7.64, -1.61],
                    [0.15, 0],
                    [0, 0],
                  ],
                  o: [
                    [-1.03, 0],
                    [-0.25, -1.2],
                    [5.14, -1.08],
                    [2.91, -9.73],
                    [-0.86, -0.87],
                    [0.87, -0.86],
                    [13.25, 13.32],
                    [-2.84, 9.49],
                    [-0.15, 0.03],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [2.22, 52.77],
                    [0.05, 51.01],
                    [1.76, 48.39],
                    [16.51, 32.31],
                    [7.65, 3.78],
                    [7.65, 0.65],
                    [10.78, 0.65],
                    [20.74, 33.57],
                    [2.66, 52.72],
                    [2.2, 52.77],
                    [2.22, 52.77],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.251, 0.3608, 0.2549] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 70,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [67.57, 34.36] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [78.53, 89.62], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [78.53, 90.62], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [78.53, 90.62], t: 72 },
                { s: [78.53, 89.62], t: 132 },
              ],
            },
            r: {
              a: 1,
              k: [
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [0], t: 0 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 60 },
                { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-6.4], t: 72 },
                { s: [0], t: 132 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [14.25, 11.02],
                    [6.27, 3.58],
                    [-1.12, 13.39],
                    [5.36, 2.76],
                    [-2.86, 11.76],
                    [-6.5, 1.89],
                    [-28.38, 7.54],
                    [0, 0],
                  ],
                  o: [
                    [-25.95, 28.3],
                    [-8.3, -6.42],
                    [-8.38, -4.79],
                    [-0.25, -3.83],
                    [-9.48, -4.89],
                    [10.1, 2.35],
                    [28.65, -8.66],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [135.15, 32.79],
                    [42.97, 65.09],
                    [34.83, 51.16],
                    [18, 34.37],
                    [11.32, 24.21],
                    [0.93, 5.85],
                    [30.6, 1.56],
                    [113.3, 15.83],
                    [135.15, 32.79],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 71,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [120, 90.26] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [120, 90.26] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, 0],
                    [0, 180.52],
                    [240, 180.52],
                    [240, 0],
                    [0, 0],
                  ],
                },
              },
            },
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0.48, -1.47],
                    [-0.83, -0.49],
                    [-0.7, 0.98],
                    [0, 0],
                    [-0.09, 0.13],
                    [-0.02, 0.01],
                    [-0.02, 0.02],
                    [0.53, 2.49],
                    [0.11, 0.26],
                    [0.08, 0.15],
                    [-0.26, 0.13],
                    [-0.14, -0.26],
                    [-0.01, -0.01],
                    [-0.06, -0.15],
                    [1.24, -1.79],
                    [0.01, -0.02],
                    [-1.29, -0.99],
                    [-0.61, 0.12],
                    [-0.01, 0.01],
                    [-0.06, 0.01],
                    [-0.09, -0.2],
                    [0.01, -0.09],
                    [0.18, -0.08],
                    [0.34, -0.11],
                    [0.56, 0],
                    [0.59, 0.36],
                    [0.05, -0.02],
                    [0.19, -1.88],
                    [0.27, 0],
                    [0, 0],
                    [-0.03, 0.29],
                    [-2.93, 1.16],
                    [-0.21, 1],
                    [1.13, 0],
                    [0.53, 0.31],
                    [-0.86, 2.69],
                    [-1.18, 1.24],
                    [0, 0],
                    [-0.21, -0.2],
                    [0.2, -0.21],
                  ],
                  o: [
                    [0, 0],
                    [-1.15, 1.23],
                    [-0.57, 1.79],
                    [1.86, 1.1],
                    [0, 0],
                    [0.08, -0.11],
                    [0, -0.02],
                    [0.02, -0.03],
                    [1.01, -1.47],
                    [-0.05, -0.27],
                    [-0.06, -0.15],
                    [-0.14, -0.26],
                    [0.26, -0.15],
                    [0.01, 0],
                    [0.08, 0.15],
                    [1.37, 3.24],
                    [-0.01, 0.02],
                    [-1.45, 2.47],
                    [0.67, 0.52],
                    [0.49, -0.1],
                    [0.06, -0.03],
                    [0.21, -0.02],
                    [0.04, 0.09],
                    [0, 0.18],
                    [-0.03, 0],
                    [-0.36, 0.11],
                    [-0.56, 0],
                    [-0.04, 0.04],
                    [-2.61, 0.83],
                    [-0.03, 0.27],
                    [0, 0],
                    [-0.29, -0.03],
                    [0.21, -1.99],
                    [-0.76, -0.91],
                    [-0.87, 0.68],
                    [-0.54, 0],
                    [-0.76, -0.45],
                    [0.55, -1.69],
                    [0, 0],
                    [0.19, -0.21],
                    [0.22, 0.2],
                    [0, 0],
                  ],
                  v: [
                    [106.65, 23.54],
                    [106.18, 24.04],
                    [103.36, 28],
                    [104.48, 31.25],
                    [109.52, 29],
                    [109.58, 28.9],
                    [109.84, 28.53],
                    [109.86, 28.49],
                    [109.92, 28.41],
                    [111.96, 21.89],
                    [111.72, 21.09],
                    [111.51, 20.65],
                    [111.73, 19.94],
                    [112.45, 20.15],
                    [112.47, 20.19],
                    [112.68, 20.65],
                    [110.78, 29.03],
                    [110.75, 29.09],
                    [110.52, 34.09],
                    [112.62, 34.47],
                    [113.47, 34.2],
                    [113.65, 34.15],
                    [114.17, 34.44],
                    [114.22, 34.71],
                    [113.93, 35.15],
                    [113.35, 35.38],
                    [111.92, 35.6],
                    [110.14, 35.12],
                    [109.99, 35.2],
                    [105.54, 40.95],
                    [105.01, 41.42],
                    [104.96, 41.42],
                    [104.48, 40.84],
                    [109.27, 34.34],
                    [108.65, 31.34],
                    [105.55, 32.6],
                    [103.94, 32.16],
                    [102.35, 27.67],
                    [105.41, 23.32],
                    [105.88, 22.82],
                    [106.62, 22.79],
                    [106.65, 23.54],
                  ],
                },
              },
            },
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [-0.14, -0.26],
                    [-0.11, -0.72],
                    [0.18, -0.88],
                    [0.1, -0.26],
                    [0.21, 0],
                    [0.07, 0.03],
                    [-0.1, 0.27],
                    [-0.01, 0.08],
                    [0.57, 1.14],
                    [-0.09, 0.15],
                    [-0.09, 0.05],
                  ],
                  o: [
                    [0.27, -0.14],
                    [0.26, 0.53],
                    [0.13, 0.96],
                    [-0.05, 0.31],
                    [-0.08, 0.21],
                    [-0.07, 0],
                    [-0.27, -0.1],
                    [0.03, -0.07],
                    [0.42, -1.3],
                    [-0.08, -0.17],
                    [0.05, -0.09],
                    [0, 0],
                  ],
                  v: [
                    [118.75, 20.59],
                    [119.47, 20.82],
                    [120.03, 22.75],
                    [119.97, 25.62],
                    [119.73, 26.49],
                    [119.24, 26.83],
                    [119.04, 26.79],
                    [118.74, 26.11],
                    [118.81, 25.88],
                    [118.52, 21.3],
                    [118.54, 20.79],
                    [118.75, 20.59],
                  ],
                },
              },
            },
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [-2.38, 1.36],
                    [-0.16, -0.13],
                    [-0.04, -0.06],
                    [0.25, -0.14],
                    [0.92, -1.58],
                    [0.18, 0],
                    [0.09, 0.05],
                    [0.04, 0.08],
                    [-0.1, 0.17],
                  ],
                  o: [
                    [0.99, -1.69],
                    [0.2, -0.11],
                    [0.06, 0.04],
                    [0.14, 0.25],
                    [-2.16, 1.23],
                    [-0.1, 0.17],
                    [-0.09, 0],
                    [-0.08, -0.05],
                    [-0.09, -0.16],
                    [0, 0],
                  ],
                  v: [
                    [100.83, 23.4],
                    [105.64, 18.24],
                    [106.23, 18.29],
                    [106.37, 18.44],
                    [106.17, 19.16],
                    [101.75, 23.94],
                    [101.29, 24.2],
                    [101.02, 24.13],
                    [100.83, 23.93],
                    [100.83, 23.4],
                  ],
                },
              },
            },
          ],
          ind: 72,
        },
        {
          ty: 4,
          nm: 'Layer_1 Bg',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [120, 91.4] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [120, 91.4] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [240, 0],
                    [240, 182.81],
                    [0, 182.81],
                    [0, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [1, 1, 1] },
              r: 1,
              o: { a: 0, k: 0 },
            },
          ],
          ind: 73,
        },
      ],
    },
    {
      nm: '[Asset] Component 3',
      id: '2',
      layers: [
        {
          ty: 0,
          nm: 'Frame 1410120007',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: true,
          ao: 0,
          ks: {
            a: { a: 0, k: [3, 132.59] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.65, y: 0 }, i: { x: 0.35, y: 0 }, s: [3, -132.41], t: 0 },
                { o: { x: 0.65, y: 0 }, i: { x: 0.35, y: 0 }, s: [3, -132.41], t: 48 },
                {
                  h: 1,
                  o: { x: 0.167, y: 0.167 },
                  i: { x: 0.833, y: 0.833 },
                  s: [3, 398.59],
                  t: 108,
                },
                {
                  h: 1,
                  o: { x: 0.167, y: 0.167 },
                  i: { x: 0.833, y: 0.833 },
                  s: [3, -132.41],
                  t: 109,
                },
                { s: [3, -132.41], t: 157 },
              ],
            },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          masksProperties: [
            {
              nm: '',
              inv: false,
              mode: 'a',
              x: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              pt: {
                a: 1,
                k: [
                  {
                    o: { x: 0.65, y: 0 },
                    i: { x: 0.35, y: 0 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 262.18],
                          [3, 265.18],
                          [3, 265.18],
                          [0, 262.18],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 0,
                  },
                  {
                    o: { x: 0.65, y: 0 },
                    i: { x: 0.35, y: 0 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 262.18],
                          [3, 265.18],
                          [3, 265.18],
                          [0, 262.18],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 48,
                  },
                  {
                    h: 1,
                    o: { x: 0.167, y: 0.167 },
                    i: { x: 0.833, y: 0.833 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 262.18],
                          [3, 265.18],
                          [3, 265.18],
                          [0, 262.18],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 108,
                  },
                  {
                    h: 1,
                    o: { x: 0.167, y: 0.167 },
                    i: { x: 0.833, y: 0.833 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 262.18],
                          [3, 265.18],
                          [3, 265.18],
                          [0, 262.18],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 109,
                  },
                  {
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 262.18],
                          [3, 265.18],
                          [3, 265.18],
                          [0, 262.18],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 157,
                  },
                ],
              },
            },
          ],
          w: 300,
          h: 300,
          refId: '3',
          ind: 1,
        },
        {
          ty: 4,
          nm: 'Component 3 Bg',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3, 132.59] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [3, 132.59] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                  ],
                  v: [
                    [6, 3],
                    [6, 262.18],
                    [3, 265.18],
                    [3, 265.18],
                    [0, 262.18],
                    [0, 3],
                    [3, 0],
                    [3, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [1, 1, 1] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 2,
        },
      ],
    },
    {
      nm: '[Asset] Frame 1410120007',
      id: '3',
      layers: [
        {
          ty: 4,
          nm: 'Frame 1410120007 Bg',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3, 132.59] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [3, 132.59] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                  ],
                  v: [
                    [6, 3],
                    [6, 262.18],
                    [3, 265.18],
                    [3, 265.18],
                    [0, 262.18],
                    [0, 3],
                    [3, 0],
                    [3, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 40 },
            },
          ],
          ind: 1,
        },
      ],
    },
    {
      nm: '[Asset] Component 5',
      id: '4',
      layers: [
        {
          ty: 0,
          nm: 'Frame 1410120007',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: true,
          ao: 0,
          ks: {
            a: { a: 0, k: [3, 65] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.65, y: 0 }, i: { x: 0.35, y: 0 }, s: [3, -65], t: 0 },
                { o: { x: 0.65, y: 0 }, i: { x: 0.35, y: 0 }, s: [3, -65], t: 60 },
                {
                  h: 1,
                  o: { x: 0.167, y: 0.167 },
                  i: { x: 0.833, y: 0.833 },
                  s: [3, 195],
                  t: 120,
                },
                {
                  h: 1,
                  o: { x: 0.167, y: 0.167 },
                  i: { x: 0.833, y: 0.833 },
                  s: [3, -65],
                  t: 121,
                },
                { s: [3, -65], t: 181 },
              ],
            },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          masksProperties: [
            {
              nm: '',
              inv: false,
              mode: 'a',
              x: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              pt: {
                a: 1,
                k: [
                  {
                    o: { x: 0.65, y: 0 },
                    i: { x: 0.35, y: 0 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 127],
                          [3, 130],
                          [3, 130],
                          [0, 127],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 0,
                  },
                  {
                    o: { x: 0.65, y: 0 },
                    i: { x: 0.35, y: 0 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 127],
                          [3, 130],
                          [3, 130],
                          [0, 127],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 60,
                  },
                  {
                    h: 1,
                    o: { x: 0.167, y: 0.167 },
                    i: { x: 0.833, y: 0.833 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 127],
                          [3, 130],
                          [3, 130],
                          [0, 127],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 120,
                  },
                  {
                    h: 1,
                    o: { x: 0.167, y: 0.167 },
                    i: { x: 0.833, y: 0.833 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 127],
                          [3, 130],
                          [3, 130],
                          [0, 127],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 121,
                  },
                  {
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 127],
                          [3, 130],
                          [3, 130],
                          [0, 127],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 181,
                  },
                ],
              },
            },
          ],
          w: 300,
          h: 300,
          refId: '5',
          ind: 1,
        },
        {
          ty: 4,
          nm: 'Component 5 Bg',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3, 65] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [3, 65] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                  ],
                  v: [
                    [6, 3],
                    [6, 127],
                    [3, 130],
                    [3, 130],
                    [0, 127],
                    [0, 3],
                    [3, 0],
                    [3, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [1, 1, 1] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 2,
        },
      ],
    },
    {
      nm: '[Asset] Frame 1410120007',
      id: '5',
      layers: [
        {
          ty: 4,
          nm: 'Frame 1410120007 Bg',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3, 65] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [3, 65] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                  ],
                  v: [
                    [6, 3],
                    [6, 127],
                    [3, 130],
                    [3, 130],
                    [0, 127],
                    [0, 3],
                    [3, 0],
                    [3, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 40 },
            },
          ],
          ind: 1,
        },
      ],
    },
    {
      nm: '[Asset] Component 4',
      id: '6',
      layers: [
        {
          ty: 0,
          nm: 'Frame 1410120007',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: true,
          ao: 0,
          ks: {
            a: { a: 0, k: [3, 90] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                { o: { x: 0.65, y: 0 }, i: { x: 0.35, y: 0 }, s: [3, -90], t: 0 },
                { o: { x: 0.65, y: 0 }, i: { x: 0.35, y: 0 }, s: [3, -90], t: 48 },
                {
                  h: 1,
                  o: { x: 0.167, y: 0.167 },
                  i: { x: 0.833, y: 0.833 },
                  s: [3, 270],
                  t: 108,
                },
                {
                  h: 1,
                  o: { x: 0.167, y: 0.167 },
                  i: { x: 0.833, y: 0.833 },
                  s: [3, -90],
                  t: 109,
                },
                { s: [3, -90], t: 157 },
              ],
            },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          masksProperties: [
            {
              nm: '',
              inv: false,
              mode: 'a',
              x: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              pt: {
                a: 1,
                k: [
                  {
                    o: { x: 0.65, y: 0 },
                    i: { x: 0.35, y: 0 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 177],
                          [3, 180],
                          [3, 180],
                          [0, 177],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 0,
                  },
                  {
                    o: { x: 0.65, y: 0 },
                    i: { x: 0.35, y: 0 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 177],
                          [3, 180],
                          [3, 180],
                          [0, 177],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 48,
                  },
                  {
                    h: 1,
                    o: { x: 0.167, y: 0.167 },
                    i: { x: 0.833, y: 0.833 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 177],
                          [3, 180],
                          [3, 180],
                          [0, 177],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 108,
                  },
                  {
                    h: 1,
                    o: { x: 0.167, y: 0.167 },
                    i: { x: 0.833, y: 0.833 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 177],
                          [3, 180],
                          [3, 180],
                          [0, 177],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 109,
                  },
                  {
                    s: [
                      {
                        c: true,
                        i: [
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 1.66],
                          [0, 0],
                          [-1.66, 0],
                          [0, 0],
                          [0, -1.66],
                          [0, 0],
                          [1.66, 0],
                        ],
                        v: [
                          [6, 3],
                          [6, 177],
                          [3, 180],
                          [3, 180],
                          [0, 177],
                          [0, 3],
                          [3, 0],
                          [3, 0],
                        ],
                      },
                    ],
                    t: 157,
                  },
                ],
              },
            },
          ],
          w: 300,
          h: 300,
          refId: '7',
          ind: 1,
        },
        {
          ty: 4,
          nm: 'Component 4 Bg',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3, 90] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [3, 90] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                  ],
                  v: [
                    [6, 3],
                    [6, 177],
                    [3, 180],
                    [3, 180],
                    [0, 177],
                    [0, 3],
                    [3, 0],
                    [3, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [1, 1, 1] },
              r: 1,
              o: { a: 0, k: 100 },
            },
          ],
          ind: 2,
        },
      ],
    },
    {
      nm: '[Asset] Frame 1410120007',
      id: '7',
      layers: [
        {
          ty: 4,
          nm: 'Frame 1410120007 Bg',
          sr: 1,
          st: 0,
          op: 133.06,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: { a: 0, k: [3, 90] },
            s: { a: 0, k: [100, 100] },
            sk: { a: 0, k: 0 },
            p: { a: 0, k: [3, 90] },
            r: { a: 0, k: 0 },
            sa: { a: 0, k: 0 },
            o: { a: 0, k: 100 },
          },
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 1.66],
                    [0, 0],
                    [-1.66, 0],
                    [0, 0],
                    [0, -1.66],
                    [0, 0],
                    [1.66, 0],
                  ],
                  v: [
                    [6, 3],
                    [6, 177],
                    [3, 180],
                    [3, 180],
                    [0, 177],
                    [0, 3],
                    [3, 0],
                    [3, 0],
                  ],
                },
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: { a: 0, k: [0.5451, 0.9334, 0.4196] },
              r: 1,
              o: { a: 0, k: 40 },
            },
          ],
          ind: 1,
        },
      ],
    },
  ],
};
